(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8754,6035,2426,2210],{

/***/ 39166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ setPostCheckoutCurrentStep; },
/* harmony export */   "L7": function() { return /* binding */ setNumberTransferDetails; },
/* harmony export */   "RL": function() { return /* binding */ setPaymentMethodUrl; },
/* harmony export */   "Z9": function() { return /* binding */ setNormalCheckoutCurrentStep; },
/* harmony export */   "j2": function() { return /* binding */ setNumberToTranfer; },
/* harmony export */   "ks": function() { return /* binding */ setNumberTranferType; },
/* harmony export */   "nK": function() { return /* binding */ removeCreditCheckStates; },
/* harmony export */   "wg": function() { return /* binding */ setPostOrderResponse; }
/* harmony export */ });
/* unused harmony export setPaymentMethodCode */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1369);



var setNormalCheckoutCurrentStep = function setNormalCheckoutCurrentStep(result) {
  return /*#__PURE__*/function () {
    var _ref = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (typeof result != "undefined" && result !== "") {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_NORMAL_CHECKOUT_CURRENT_STEP */ .GT,
                  payload: result
                });
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var setPostCheckoutCurrentStep = function setPostCheckoutCurrentStep(result) {
  return /*#__PURE__*/function () {
    var _ref2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (typeof result != "undefined" && result !== "") {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_POST_CHECKOUT_CURRENT_STEP */ .$u,
                  payload: result
                });
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var setNumberTranferType = function setNumberTranferType(type) {
  return {
    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_NUMBER_TRANSFER_TYPE */ .bb,
    payload: type
  };
};
var setNumberToTranfer = function setNumberToTranfer(number) {
  return {
    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_NUMBER_TO_TRANSFER */ .Gm,
    payload: number
  };
};
var setNumberTransferDetails = function setNumberTransferDetails(payload) {
  return {
    type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_NUMBER_TRANSFER_DETAILS */ .Kc,
    payload: payload
  };
};
var removeCreditCheckStates = function removeCreditCheckStates(result) {
  return /*#__PURE__*/function () {
    var _ref3 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (typeof result != "undefined" && result !== "") {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_CHECK_PERSONAL_DATA */ .bP,
                  payload: result
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_CHECK_EMPLOYMENT_DATA */ .yP,
                  payload: result
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_CHECK_HOME_DATA */ .nd,
                  payload: result
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_CHECK_DEBIT_DATA */ .cq,
                  payload: result
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_CHECK_DELIVERY_DATA */ .pM,
                  payload: result
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_CHECK_CONTACT_DATA */ .HM,
                  payload: result
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_CHECK_AFFORD_DEAL */ .n1,
                  payload: false
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_SELECTED_AFFORD_DEAL */ ._c,
                  payload: true
                });
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_CREDIT_VETTING_OUTCOME */ .DI,
                  payload: result
                });
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var setPaymentMethodCode = function setPaymentMethodCode(result) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (typeof result != undefined && result != "") {
                dispatch({
                  type: SET_PAYMENT_METHOD,
                  payload: result
                });
              }

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var setPaymentMethodUrl = function setPaymentMethodUrl(result) {
  return /*#__PURE__*/function () {
    var _ref5 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (typeof result != undefined && result != "") {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_PAYMENT_METHOD_URL */ .VM,
                  payload: result
                });
              }

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var setPostOrderResponse = function setPostOrderResponse(result) {
  return /*#__PURE__*/function () {
    var _ref6 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(dispatch) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (typeof result != undefined && result != "") {
                dispatch({
                  type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_2__/* .SET_POST_ORDER_RESPONSE */ .jw,
                  payload: result
                });
              }

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ 15623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ resetSyncUserProfile; },
  "c": function() { return /* binding */ syncUserProfile; }
});

;// CONCATENATED MODULE: ./utils/CreateThunk.js
var createThunk = function createThunk(_ref) {
  var apiCall = _ref.apiCall,
      type = _ref.type;
  return function (requestPayload) {
    return function (dispatch, getState) {
      dispatch({
        payload: requestPayload,
        type: type
      });
      return apiCall({
        getState: getState,
        payload: requestPayload
      }).then(function (payload) {
        return dispatch({
          type: "".concat(type, "_SUCCESS"),
          payload: payload,
          requestPayload: requestPayload
        });
      }, function (payload) {
        return dispatch({
          type: "".concat(type, "_FAILURE"),
          payload: payload,
          requestPayload: requestPayload
        });
      });
    };
  };
};
var createRejectableThunk = function createRejectableThunk(_ref2) {
  var apiCall = _ref2.apiCall,
      type = _ref2.type;
  return function (requestPayload) {
    return function (dispatch, getState) {
      dispatch({
        payload: requestPayload,
        type: type
      });
      return apiCall({
        getState: getState,
        payload: requestPayload
      }).then(function (payload) {
        return dispatch({
          type: "".concat(type, "_SUCCESS"),
          payload: payload,
          requestPayload: requestPayload
        });
      });
    };
  };
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./utils/microServices.js
var microServices = __webpack_require__(49366);
;// CONCATENATED MODULE: ./services/userProfileService.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var syncUserPorfile = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var _profileInfoRequest$r, _profileInfoRequest$r2, _profileInfo$result, _profileInfo$result2, _profileInfoRequest$e;

    var payload, params, profileInfoRequest, profileInfo;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload;

            if (payload.cartId) {
              params = {
                guestCartId: payload.cartId
              };
            }

            _context.next = 4;
            return microServices/* default.post */.Z.post("api", "profileSync", {}, params);

          case 4:
            profileInfoRequest = _context.sent;
            profileInfo = (_profileInfoRequest$r = profileInfoRequest.response) === null || _profileInfoRequest$r === void 0 ? void 0 : (_profileInfoRequest$r2 = _profileInfoRequest$r.data) === null || _profileInfoRequest$r2 === void 0 ? void 0 : _profileInfoRequest$r2.result;

            if (!(!profileInfoRequest.fail && profileInfo && profileInfo !== null && profileInfo !== void 0 && profileInfo.result && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result = profileInfo.result) !== null && _profileInfo$result !== void 0 && _profileInfo$result.magentoProfileResponse && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result2 = profileInfo.result) !== null && _profileInfo$result2 !== void 0 && _profileInfo$result2.magentoProfileResponse[0])) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _objectSpread(_objectSpread({}, profileInfo), {}, {
              pageAction: payload.pageAction
            }));

          case 10:
            if (!(((_profileInfoRequest$e = profileInfoRequest.error) === null || _profileInfoRequest$e === void 0 ? void 0 : _profileInfoRequest$e.status) == 401)) {
              _context.next = 14;
              break;
            }

            throw {
              apiFailStatus: "401"
            };

          case 14:
            throw new Error();

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function syncUserPorfile(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
;// CONCATENATED MODULE: ./Redux/actions/userProfileAction.js



var syncUserProfile = createThunk({
  apiCall: syncUserPorfile,
  type: actionTypes/* SYNC_USER_PROFILE */.fR
});
var resetSyncUserProfile = function resetSyncUserProfile() {
  return {
    type: actionTypes/* SYNC_USER_PROFILE_RESET */.gC
  };
};

/***/ }),

/***/ 55120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27812);
/* harmony import */ var _BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89744);
/* harmony import */ var _BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _Redux_actionTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var BreadCrumb = function BreadCrumb(_ref) {
  var list = _ref.list,
      title = _ref.title,
      replacePageTitle = _ref.replacePageTitle;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .componentResize */ .Y4)();
  var itemsBefore = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.items_display_before_collapser_mbl */ .Z.BreadCrumbLabels.items_display_before_collapser_mbl;
  var itemsAfter = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.items_display_after_collapser_mbl */ .Z.BreadCrumbLabels.items_display_after_collapser_mbl;
  var breadcrumbList = [];
  var currentPage = {};
  var lastItem;
  var router = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var dispatch = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useDispatch)();
  var isMiniApp = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getCookieValue */ .Do)("miniApp") === "true";

  var handleClick = function handleClick(url) {
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
    dispatch({
      type: _Redux_actionTypes__WEBPACK_IMPORTED_MODULE_4__/* .BREADCRUMB_SELECT */ .T1,
      payload: true
    });

    if ((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .internalUrl */ .az)(url).url === "/") {
      if (true) {
        var origin = window.location.origin; // .then(()=>{

        window.location.assign(origin);
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)(); // window.lo
        // })
      }
    } else {
      router.push((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .internalUrl */ .az)(url).url).then(function () {
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
      });
    }
  };

  function handleBreadCrumbMobile(breadcrumbList) {
    if (isMobile && breadcrumbList.length > _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.max_display_items_mbl */ .Z.BreadCrumbLabels.max_display_items_mbl) {
      breadcrumbList.splice.apply(breadcrumbList, [0, breadcrumbList.length].concat((0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breadcrumbList.slice(0, itemsBefore)), [{
        title: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile */ .Z.BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile
      }], (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breadcrumbList.slice(breadcrumbList.length - itemsAfter, breadcrumbList.length))));
    }

    lastItem = breadcrumbList.length - 1;
    return breadcrumbList;
  }

  if (list) {
    var totalKeys = Object.keys(list).length; // Mapping current page object into currentPage

    if (totalKeys > 0) {
      currentPage = Object.values(list)[totalKeys - 1];
    }

    Object.entries(list).forEach(function (value) {
      var replacedTitle = title && value[1].url === currentPage.url ? title : null;
      var replacePageTitleBool = replacePageTitle && value[1].url === currentPage.url ? true : false;
      var matchedRoute = {
        url: value[1].url,
        title: value[0],
        replacedTitle: replacedTitle,
        replacePageTitle: replacePageTitleBool
      };
      breadcrumbList.push(matchedRoute);
    });
    lastItem = breadcrumbList.length - 1;
  }

  return isMiniApp || breadcrumbList.length === 0 || breadcrumbList.length === 1 && breadcrumbList[0].url == "/" ? "" : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Nav, {
    className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-wrapper"])),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ol", {
      className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-list"])),
      children: handleBreadCrumbMobile(breadcrumbList).map(function (bcrumb, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
          className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-item"])),
          id: "".concat(index, "_").concat(bcrumb.title),
          children: lastItem !== index && bcrumb.url ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            id: "".concat(index, "_").concat(bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title),
            onClick: function onClick() {
              return handleClick(bcrumb.url);
            },
            children: ["                    ", bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title]
          }) : bcrumb.replacePageTitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            id: "".concat(index, "_").concat(bcrumb.replacedTitle),
            children: bcrumb.replacedTitle
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            id: "".concat(index, "_").concat(bcrumb.title),
            children: bcrumb.title
          })
        }, index);
      })
    })
  });
};

BreadCrumb.defaultProps = {
  list: null,
  title: "",
  replacePageTitle: false
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 85092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2814);
/* harmony import */ var _DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var DropDownComponent = function DropDownComponent(props) {
  var selectedValue = props.selectedValue,
      data = props.data,
      handleSelect = props.handleSelect,
      longest = props.longest,
      menuClassName = props.menuClassName,
      id = props.id;

  var checkVal = function checkVal(e) {
    handleSelect(e);
  };

  var menuWidth = (longest + 2) * 2 / 3;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.DropdownButton, {
    id: "drop-down-button-".concat(id),
    title: selectedValue,
    alignRight: true,
    bsPrefix: "".concat((_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["dropdown-button"]), " ").concat(props.customClass, " selected-").concat((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .toDesignation */ .ke)(selectedValue)),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      style: {
        width: "".concat(menuWidth, "rem")
      },
      className: (_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[menuClassName],
      children: data.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Dropdown.Item, {
          className: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .toDesignation */ .ke)(item.label),
          eventKey: item.label,
          bsPrefix: (_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().dropdown),
          onSelect: checkVal,
          id: "".concat(index, "_").concat(item.label),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("label", {
            className: (_DropDownStyle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
            children: item.label
          })
        }, index);
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DropDownComponent);

/***/ }),

/***/ 38975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88447);
/* harmony import */ var _LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var LabelText = function LabelText(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClickHandler = _ref.onClickHandler,
      uniqueLabelId = _ref.uniqueLabelId;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
    className: "".concat(className, " ").concat((_LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["label-text"])),
    style: style,
    onClick: onClickHandler,
    id: uniqueLabelId,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LabelText);

/***/ }),

/***/ 19456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9213);
/* harmony import */ var _pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var PageHeading = function PageHeading(_ref) {
  var text = _ref.text,
      className = _ref.className,
      level = _ref.level,
      variant = _ref.variant,
      alignment = _ref.alignment,
      id = _ref.id;
  var heading;
  var variantClass = variant ? "page-heading--".concat(variant) : "";
  var newId = id ? id : "heading-" + text;

  var generateAlignment = function generateAlignment() {
    switch (alignment) {
      case "left":
      case "LEFT":
        return alignment ? "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())["alignment--" + alignment.toLowerCase()]) : "";

      case "RIGHT":
      case "right":
        return alignment ? "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())["alignment--" + alignment.toLowerCase()]) : "";

      default:
        return "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["alignment--center"]));
    }
  };

  switch (level) {
    case 4:
      heading = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
        className: "".concat(className, " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variantClass], " ").concat(generateAlignment()),
        id: newId,
        dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .createMarkup */ .KU)(text)
      });
      break;

    case 3:
      heading = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
        className: "".concat(className, " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variantClass], " ").concat(generateAlignment()),
        id: newId,
        children: text
      });
      break;

    case 2:
      heading = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
        className: "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["page-heading"]), " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["page-heading--l2"]), " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variantClass], " ").concat(className),
        dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .createMarkup */ .KU)(text),
        id: newId
      });
      break;

    default:
      heading = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
        className: "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["page-heading"]), " ").concat(variantClass, " ").concat(className, " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variantClass]),
        id: newId,
        dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .createMarkup */ .KU)(text)
      });
  }

  return heading;
};

PageHeading.defaultProps = {
  text: "",
  level: 1,
  className: "",
  variant: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeading);

/***/ }),

/***/ 4648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tag_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58428);
/* harmony import */ var _tag_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tag_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Tag = function Tag(_ref) {
  var label = _ref.label,
      variant = _ref.variant,
      className = _ref.className,
      labelColor = _ref.labelColor;
  var labels = {
    custom: label,
    "brand-new": label || "Brand new",
    discount: label || "X% off",
    "device-deal": label || "Double device deal",
    "limited-offer": label || "Limited offer",
    "low-stock": label || "Low stock",
    "no-stock": label || "Out of stock",
    "on-backorder": label || "Currently on backorder",
    "pre-order": label || "Pre-order",
    "top-pick": label || "Top pick",
    "currently-viewing": label || "Currently viewing",
    "one-time-offer": label || "One-time offer",
    "today-only": label || "Today Only",
    "for-today-only": label || "For today only",
    "exclusive-to-online": label || "Exclusive to Online",
    "read-hot-dealz": label || "Red Hot Dealz",
    "red-hot-deal": label || "Red Hot Deal",
    "buy-one-get-one-free": label || "Buy One Get One Free",
    "Black-Friday": "Black Friday",
    "black-friday": label || "Black Friday",
    "badge-style-1": label || "badge-style-1",
    Recommended: label || "Recommended"
  };

  var colorValue = function colorValue(value, defaultColor) {
    switch (value) {
      case "no-stock":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Red75 */ .Z.Red75);
        }

      case "low-stock":
      case "on-backorder":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Yellow50 */ .Z.Yellow50);
        }

      case "discount":
      case "buy-one-get-one-free":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Teal51 */ .Z.Teal51);
        }

      case "pre-order":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Teal75 */ .Z.Teal75);
        }

      case "top-pick":
      case "Recommended":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Purple53 */ .Z.Purple53);
        }

      default:
        return defaultColor && defaultColor !== null ? defaultColor : labelColor;
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    id: labels[variant] ? "tag_".concat(labels[variant.toLowerCase()]) : "tag_".concat(label),
    className: "".concat((_tag_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tag), " ").concat(className),
    style: {
      backgroundColor: labelColor && labelColor !== null ? colorValue(variant) : colorValue(variant, "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Black40 */ .Z.Black40))
    },
    children: labels[variant] ? labels[variant.toLowerCase()] : label
  });
};

Tag.defaultProps = {
  variant: "custom",
  className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Tag);

/***/ }),

/***/ 76035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41898);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99599);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








var ButtonGroup = function ButtonGroup(props) {
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_4___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_4___default().envConfigs)[env].imagePrefix;
  var toggleVal = props.filterType ? props.filterType : "filter";

  var generateImageUrl = function generateImageUrl() {
    switch (props.filterType) {
      case "filter":
        return "".concat(imagePrefix, "/assets/images/filter.svg");

      case "search":
        return "".concat(imagePrefix, "/assets/images/search.svg");

      default:
        return "".concat(imagePrefix, "/assets/images/filter.svg");
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash),
    children: [props.hide ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "hide",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "d-block d-lg-none",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("button", {
          onClick: function onClick() {
            return props.toggleComps(toggleVal);
          },
          className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "left-btn",
          children: "Filter"
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("button", {
          onClick: function onClick() {
            return props.toggleComps(toggleVal);
          },
          id: "".concat(_config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_filter_products */ .Z.lbl_filter_products, "-fiter-arrow"),
          className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "filters-mobile-button ".concat(props.noShadow ? "no-shadow" : "", " left-btn-md pl-0"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
            src: generateImageUrl(),
            alt: "filter",
            className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "button-image"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("span", {
            className: "jsx-".concat(_ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash) + " " + "button-label",
            children: [" ", props.buttonLabel ? props.buttonLabel : _config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_filter_products */ .Z.lbl_filter_products]
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: _ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle.__hash */ .Y.__hash,
      children: _ButtonGroupStyle__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroupStyle */ .Y
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ButtonGroup);

/***/ }),

/***/ 41898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ButtonGroupStyle; }
/* harmony export */ });
/* harmony import */ var _config_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);
/* harmony import */ var _config_fonts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78198);


var ButtonGroupStyle = [".left-btn.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].bold */ .Z.bold, " !important;font-weight:500;font-size:1rem;float:left;width:50%;border:solid 0.6px ").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey20 */ .Z.Grey20, ";height:50px;text-align:center;background-color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].White0 */ .Z.White0, ";}"), ".right-btn.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].bold */ .Z.bold, " !important;font-weight:700;font-size:1rem;float:right;border:solid 0.6px ").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey20 */ .Z.Grey20, ";border-left:none;width:50%;height:50px;text-align:center;background-color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].White0 */ .Z.White0, ";}"), ".left-btn-md.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].medium */ .Z.medium, " !important;font-weight:700;font-size:1rem;float:left;padding-left:1rem;width:48%;box-shadow:0 0.5rem 1rem 0 rgba(0,0,0,0.2);border:solid 0.6px ").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey20 */ .Z.Grey20, ";height:3.125rem;text-align:left;background-color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].White0 */ .Z.White0, ";border-radius:4px;padding-right:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}"), ".right-btn-md.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].medium */ .Z.medium, " !important;font-weight:700;font-size:1rem;padding-left:1rem;float:right;box-shadow:0 0.5rem 1rem 0 rgba(0,0,0,0.2);border:solid 0.6px ").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey20 */ .Z.Grey20, ";min-width:48%;height:3.125rem;text-align:left;background-color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].White0 */ .Z.White0, ";border-radius:4px;padding-right:0;}"), ".right-arrow.jsx-2226485967{margin-top:0.4rem;width:0.6875rem;height:0.6875rem;float:right;margin-right:0.9375rem;}", ".button-text.jsx-2226485967{font-family:".concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].regular */ .Z.regular, ";font-weight:400;color:").concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Grey70 */ .Z.Grey70, ";}"), ".button-image.jsx-2226485967{width:1.1875rem;height:1.1875rem;}", ".button-label.jsx-2226485967{color:".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Black40 */ .Z.Black40, ";font-family:").concat(_config_fonts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].medium */ .Z.medium, ";font-size:1rem;font-weight:500;margin:0 0.3rem 0 0.5rem;}"), ".button-grid-gutter.jsx-2226485967{margin-left:-1rem !important;margin-right:-1rem !important;}", ".no-shadow.jsx-2226485967{box-shadow:none;border-color:".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Black40 */ .Z.Black40, ";padding-left:0rem;text-align:center;}"), "@media screen and (max-width:576px){.left-btn-md.jsx-2226485967,.right-btn-md.jsx-2226485967{width:100%;float:none;text-align:center;}.right-btn-md.jsx-2226485967{margin-top:0.5rem;}}", "@media screen and (max-width:320px){.right-arrow.jsx-2226485967{padding-right:0;}}", "@media screen and (min-width:768px){.right-btn-md.jsx-2226485967,.left-btn-md.jsx-2226485967{width:21.75rem;}}"];
ButtonGroupStyle.__hash = "2226485967";

/***/ }),

/***/ 37665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var FilterButtons = function FilterButtons(props) {
  var sortData = props.sortData;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;

  var getSortLabel = function getSortLabel() {
    for (var i = 0; i < sortData.length; i++) {
      if (props.sortValue == sortData[i].id) {
        return sortData[i].name;
      }
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
      className: "buy-bundle-container__filter top-filter",
      onClick: function onClick() {
        return props.SetShowModal(true);
      },
      id: "filter-bundles-btn",
      children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
        className: "button-image",
        src: "".concat(imagePrefix, "/assets/images/filter.svg"),
        alt: "filter"
      }), "Filter bundles", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
        className: "v-icon-caret-right right-arrow"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
      onClick: function onClick() {
        return props.setSortModal(true);
      },
      id: "sort-bundles-btn",
      className: "buy-bundle-container__filter",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
        className: "button-image",
        src: "".concat(imagePrefix, "/assets/images/sort.svg"),
        alt: "sort"
      }), "Sort by", ": ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
        className: "button-text",
        children: [" ", getSortLabel(), " "]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
        className: "v-icon-caret-right right-arrow"
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterButtons);

/***/ }),

/***/ 71881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ filterNav_FilterNav; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./components/atoms/arrow/Arrow.module.scss
var Arrow_module = __webpack_require__(92156);
var Arrow_module_default = /*#__PURE__*/__webpack_require__.n(Arrow_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/arrow/Arrow.jsx





var Arrow = function Arrow(props) {
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
    className: (Arrow_module_default())["icon-arrow"],
    src: "".concat(imagePrefix, "/assets/images/icon-arrow-left.svg"),
    onClick: props.back,
    id: props.id
  });
};

/* harmony default export */ var arrow_Arrow = (Arrow);
// EXTERNAL MODULE: ./components/molecules/filterNav/filterNav.module.scss
var filterNav_module = __webpack_require__(12940);
var filterNav_module_default = /*#__PURE__*/__webpack_require__.n(filterNav_module);
;// CONCATENATED MODULE: ./components/molecules/filterNav/FilterNav.jsx






var FilterNav = function FilterNav(_ref) {
  var _ref$headingName = _ref.headingName,
      headingName = _ref$headingName === void 0 ? 'Filters' : _ref$headingName,
      _ref$lableName = _ref.lableName,
      lableName = _ref$lableName === void 0 ? 'Reset All' : _ref$lableName,
      backbtn = _ref.backbtn,
      resetClickHandler = _ref.resetClickHandler,
      isCategoryError = _ref.isCategoryError,
      selectedFilter = _ref.selectedFilter,
      _ref$filterType = _ref.filterType,
      filterType = _ref$filterType === void 0 ? "" : _ref$filterType;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
    className: (filterNav_module_default()).header,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(arrow_Arrow, {
      back: backbtn,
      id: "".concat(headingName, "-filter-nav-bckBtn")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (filterNav_module_default()).heading,
      children: headingName
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: resetClickHandler,
      className: filterType == "filter_by_product" ? selectedFilter !== null && selectedFilter !== void 0 && selectedFilter.search ? (filterNav_module_default()).btnReset : (filterNav_module_default()).hideBtnReset : selectedFilter ? (filterNav_module_default()).btnReset : (filterNav_module_default()).hideBtnReset,
      id: "".concat(headingName, "-resetBtn"),
      children: headingName == "Filter deals" || headingName == "Filter products" ? lableName : "Reset"
    })]
  });
};

/* harmony default export */ var filterNav_FilterNav = (FilterNav);

/***/ }),

/***/ 46325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99599);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69152);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64036);
/* harmony import */ var _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39166);
/* harmony import */ var _utils_paymentIntegrationServices__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40547);
/* harmony import */ var _atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79549);
/* harmony import */ var _data_mockRenderComponent__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29151);
/* harmony import */ var _orderHistoryLoadMore_OrderHistoryLoadMore__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47091);
/* harmony import */ var _atoms_image_image__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(39489);
/* harmony import */ var _OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81076);
/* harmony import */ var _OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var OrderHistoryList = function OrderHistoryList(props) {
  var _props$pageInfo, _props$dataList, _props$pageInfo2, _props$dataList2, _props$pageInfo3;

  var router = (0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var authToken = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getCookieValue */ .Do)("auth_token");
  var vodAuthToken = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getCookieValue */ .Do)("vod-web-auth-token");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      postOrderData = _useState[0],
      setPostOrderData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      selectedIncrementId = _useState2[0],
      setSelectedIncrementId = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      paymentUrl = _useState3[0],
      setPaymentUrl = _useState3[1];

  var env = (_config_index__WEBPACK_IMPORTED_MODULE_5___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_5___default().envConfigs)[env].imagePrefix;
  var shoppingUrlPrefix = (_config_index__WEBPACK_IMPORTED_MODULE_5___default().envConfigs)[env].shoppingUrlPrefix;
  var paymentCallbackUrl = (_config_index__WEBPACK_IMPORTED_MODULE_5___default().envConfigs)[env].paymentCallback;
  var postPaymentCallbackUrl = (_config_index__WEBPACK_IMPORTED_MODULE_5___default().envConfigs)[env].postPaymentCallback;
  var paymentProvision = (_config_index__WEBPACK_IMPORTED_MODULE_5___default().envConfigs)[env].paymentProvision;
  var paymentConfig = props === null || props === void 0 ? void 0 : props.paymentConfiguration;
  var isTablet = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .componentCheckSize */ .Qj)() <= 992;
  var currentPage = props === null || props === void 0 ? void 0 : (_props$pageInfo = props.pageInfo) === null || _props$pageInfo === void 0 ? void 0 : _props$pageInfo.current_page;
  var totalLength = props === null || props === void 0 ? void 0 : (_props$dataList = props.dataList) === null || _props$dataList === void 0 ? void 0 : _props$dataList.length;
  var totalPages = props === null || props === void 0 ? void 0 : (_props$pageInfo2 = props.pageInfo) === null || _props$pageInfo2 === void 0 ? void 0 : _props$pageInfo2.total_pages;
  var FilterText = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getDisplayedRange */ .x7)(totalLength, props === null || props === void 0 ? void 0 : props.totalItemsCount, _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_past_orders_found */ .Z.lbl_past_orders_found);

  var increasePageCount = function increasePageCount() {
    if (currentPage < totalPages) {
      props.updateCurrentPage(currentPage + 1);
    }
  };

  var generateVariant = function generateVariant(orderStatus) {
    return "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-status"]), " ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default())[(0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .generateOrderCSSVariant */ .oU)(orderStatus)]);
  };

  var onOrderClick = function onOrderClick(event, detail) {
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__/* .getUtagData */ .GS()), {}, {
      link_type: "o",
      link_name: "checkout: order history: view order details",
      order_type: "once off purchase",
      order_status: "in progress",
      sales_order_id: detail
    }));
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .showSpinner */ .yh)();
    router.push({
      pathname: "".concat(shoppingUrlPrefix, "/view-order-details/").concat(detail)
    });
  };

  var handleTrackOrder = function handleTrackOrder(orderId, waybillNumber) {
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__/* .getUtagData */ .GS()), {}, {
      link_type: "o",
      link_name: "checkout: order history: track order",
      order_type: "once off purchase",
      order_status: "in progress",
      sales_order_id: orderId
    }));
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .showSpinner */ .yh)();
    router.push({
      pathname: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingUrl */ .SQ)(waybillNumber, orderId)
    });
  };

  var orderRouter = function orderRouter(orderResult) {
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .showSpinner */ .yh)();
    var postOrder = JSON.parse(JSON.stringify(_data_mockRenderComponent__WEBPACK_IMPORTED_MODULE_12__.productOrderReq).replace(/\:null/gi, ':""')); //replace null with "" for all attributes

    var headers = {};

    if (vodAuthToken) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-jwt": "Bearer ".concat(vodAuthToken),
        "x-magento-token": "Bearer ".concat(authToken)
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    }

    var url = "".concat((_config_index__WEBPACK_IMPORTED_MODULE_5___default().envConfigs)[(_config_index__WEBPACK_IMPORTED_MODULE_5___default().env)].dxl.url).concat((_config_index__WEBPACK_IMPORTED_MODULE_5___default().api.postpaidProductOrder));
    postOrder.productOrder[0].productOrderState = orderResult === null || orderResult === void 0 ? void 0 : orderResult.status;
    postOrder.productOrder[0].productOrderId = orderResult === null || orderResult === void 0 ? void 0 : orderResult.increment_id;
    postOrder.productOrder[0].orderReference = orderResult !== null && orderResult !== void 0 && orderResult.waybill_number ? orderResult.waybill_number : "";
    axios__WEBPACK_IMPORTED_MODULE_3___default().post(url, postOrder, {
      headers: headers
    }).then(function (response) {
      var _data$productOrders;

      var _ref = response || {},
          data = _ref.data;

      if (data && data !== null && data !== void 0 && (_data$productOrders = data.productOrders) !== null && _data$productOrders !== void 0 && _data$productOrders.length) {
        setPostOrderData(data.productOrders[0]);
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .setCookieConsentWrapper */ .ol)("cookie_".concat((_config_index__WEBPACK_IMPORTED_MODULE_5___default().order_id)), [(_config_index__WEBPACK_IMPORTED_MODULE_5___default().cookie_category.strictly_necessary)], "document.cookie='".concat((_config_index__WEBPACK_IMPORTED_MODULE_5___default().order_id), "=").concat(data.productOrders[0].productOrderId, ";path=/'"));

        if (props.isMiniApp) {
          router.push("/shopping/mini-app/retry-payment/".concat(orderResult === null || orderResult === void 0 ? void 0 : orderResult.increment_id));
          return;
        }

        if (props.paymentOptionsEnabled) {
          var redirectUrl = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isMultiOrder */ .NO)(orderResult === null || orderResult === void 0 ? void 0 : orderResult.order_type) ? postPaymentCallbackUrl : paymentCallbackUrl;
          getIntentData(orderResult, data.productOrders[0].productOrderId, redirectUrl);
        } else {
          redirectToPayment(orderResult);
        }
      } else {
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .hideSpinner */ .v3)();
        handleApiFailure(orderResult === null || orderResult === void 0 ? void 0 : orderResult.increment_id, orderResult === null || orderResult === void 0 ? void 0 : orderResult.order_type);
      }
    })["catch"](function () {
      (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .hideSpinner */ .v3)();
      handleApiFailure(orderResult === null || orderResult === void 0 ? void 0 : orderResult.increment_id, orderResult === null || orderResult === void 0 ? void 0 : orderResult.order_type);
    });
  };

  var getIntentData = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderResult, productOrderId, redirectUrl) {
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _utils_paymentIntegrationServices__WEBPACK_IMPORTED_MODULE_10__/* ["default"].getPaymentIntent */ .Z.getPaymentIntent(productOrderId, redirectUrl).then(function (res) {
                var _res$response;

                if (!res.fail && (_res$response = res.response) !== null && _res$response !== void 0 && _res$response.data) {
                  var _res$response$data;

                  setPaymentUrl((_res$response$data = res.response.data) === null || _res$response$data === void 0 ? void 0 : _res$response$data.paymentUrl);
                } else {
                  var _res$error, _res$error$data, _res$error$data$resul, _res$error2, _res$error2$data, _res$error3;

                  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__/* .getUtagData */ .GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(res !== null && res !== void 0 && (_res$error = res.error) !== null && _res$error !== void 0 && (_res$error$data = _res$error.data) !== null && _res$error$data !== void 0 && (_res$error$data$resul = _res$error$data.result) !== null && _res$error$data$resul !== void 0 && _res$error$data$resul.message ? res.error.data.result.message : res !== null && res !== void 0 && (_res$error2 = res.error) !== null && _res$error2 !== void 0 && (_res$error2$data = _res$error2.data) !== null && _res$error2$data !== void 0 && _res$error2$data.message ? res.error.data.message : ""),
                    page_errors_code: "chk-dxl-g-id-".concat(res === null || res === void 0 ? void 0 : (_res$error3 = res.error) === null || _res$error3 === void 0 ? void 0 : _res$error3.status)
                  }));
                }

                redirectToPayment(orderResult);
              })["catch"](function (err) {
                if (err) {
                  var _err$response;

                  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_6__/* .getUtagData */ .GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(err.message ? err.message : ""),
                    page_errors_code: "chk-dxl-g-id-".concat(err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status)
                  }));
                }

                redirectToPayment(orderResult);
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getIntentData(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var redirectToPayment = function redirectToPayment(orderResult) {
    var _child_node$;

    var form_element = document.getElementById(orderResult === null || orderResult === void 0 ? void 0 : orderResult.increment_id);
    var child_node = form_element === null || form_element === void 0 ? void 0 : form_element.childNodes;
    window.setTimeout(child_node === null || child_node === void 0 ? void 0 : (_child_node$ = child_node[0]) === null || _child_node$ === void 0 ? void 0 : _child_node$.submit.bind(child_node === null || child_node === void 0 ? void 0 : child_node[0]), 800);
  };

  var handleApiFailure = function handleApiFailure(id, orderType) {
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .setCookieConsentWrapper */ .ol)("cookie_".concat((_config_index__WEBPACK_IMPORTED_MODULE_5___default().order_id)), [(_config_index__WEBPACK_IMPORTED_MODULE_5___default().cookie_category.strictly_necessary)], "document.cookie='".concat((_config_index__WEBPACK_IMPORTED_MODULE_5___default().order_id), "=").concat(id, ";path=/'"));

    if ((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isMultiOrder */ .NO)(orderType)) {
      props === null || props === void 0 ? void 0 : props.setPostCheckoutCurrentStep("paymentError");
    } else {
      props === null || props === void 0 ? void 0 : props.setNormalCheckoutCurrentStep("paymentError");
    }

    window.location.href = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isMultiOrder */ .NO)(orderType) ? "".concat(shoppingUrlPrefix, "/post-checkout") : "".concat(shoppingUrlPrefix, "/checkout");
  };

  var handleSubmit = function handleSubmit(event, item) {
    event.preventDefault();
    setSelectedIncrementId(item === null || item === void 0 ? void 0 : item.increment_id);
    orderRouter(item);
  };

  var displayTrackOrderBtn = function displayTrackOrderBtn(item) {
    var trackBtn = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .orderPageButtons */ .Rx)(item.status).displayTrackOrderBtn;
    if ((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isOnceOffOrder */ .y7)(item.order_type)) return trackBtn;
    return (props === null || props === void 0 ? void 0 : props.trackOrderEnabled) && trackBtn;
  };

  var getExtraSpaceClass = function getExtraSpaceClass(item) {
    var msg = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getOrderBlurb */ .bm)(item === null || item === void 0 ? void 0 : item.status);
    return msg ? "" : "empty-block";
  };

  var renderBlurbMsg = function renderBlurbMsg(item) {
    var msg = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getOrderBlurb */ .bm)(item === null || item === void 0 ? void 0 : item.status);
    return msg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
      className: (_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["blurb-message"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
        className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["blurb-message--inner"])),
        children: msg
      })
    });
  };

  var renderOrderImage = function renderOrderImage(item) {
    var images = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getOrderProductImageUrl */ .JA)(item, "image", "No_image");
    return (images || []).map(function (imgItem, index1) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
        className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default().rectangle), " d-inline-block"),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
          src: imgItem,
          alt: "productThumb"
        })
      }, "order-image-".concat(item === null || item === void 0 ? void 0 : item.increment_id, "-").concat(index1));
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
      className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-list"]), " mb-l"),
      children: [isTablet && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.Container, {
        className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-list-pagination"])),
        children: FilterText
      }), props === null || props === void 0 ? void 0 : (_props$dataList2 = props.dataList) === null || _props$dataList2 === void 0 ? void 0 : _props$dataList2.map(function (item, index) {
        var _postOrderData$paymen;

        return (item === null || item === void 0 ? void 0 : item.status) !== "CREATE_MAGENTO_SUCCESS" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.Container, {
          id: "order-card-".concat(index),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
            className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-card-col"])),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.Row, {
              className: "mx-0",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.Col, {
                className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["left-col"]), " pl-0 pr-0"),
                lg: 8,
                md: 9,
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
                  className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-number-block"])),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_14__["default"], {
                    img_path: "".concat(imagePrefix, "/assets/images/").concat((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .generateOrderIconVariant */ .XI)(item.status)),
                    img_width: "1.875rem",
                    img_height: "1.875rem",
                    className: "order-status-icon"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("span", {
                    className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-number"])),
                    children: [_config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_order_number_hash */ .Z.lbl_order_number_hash, item.increment_id]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
                  className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["type-block"]), " ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default())[getExtraSpaceClass(item)]),
                  children: [item === null || item === void 0 ? void 0 : item.order_type.map(function (orderTypeItem, index2) {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("span", {
                      className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product-type"])),
                      children: orderTypeItem
                    }, index2);
                  }), (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getOrderTypeAndLabel */ .AT)(item.status).orderStatusLabel !== "" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("span", {
                    className: generateVariant(item.status),
                    children: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getOrderTypeAndLabel */ .AT)(item.status).orderStatusLabel
                  })]
                }), renderBlurbMsg(item), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
                  className: (_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["product-thumb-img"]),
                  children: renderOrderImage(item)
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.Col, {
                className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["right-col"]), " pl-0 pr-0 ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["custom-history-view-tablet"])),
                lg: 4,
                md: 3,
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
                  children: [((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isDealOrder */ .AA)(item.order_type) || !(0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isOnceOffOrder */ .y7)(item.order_type)) && (item === null || item === void 0 ? void 0 : item.monthly_recurring) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
                    className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-total-box"]), " mb-s d-flex ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["custom-history-price"]), " ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["custom-history-button"]), " ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-row-total-monthly"])),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("span", {
                      className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-monthly-total-lbl"])),
                      children: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_order_monthly_total */ .Z.lbl_order_monthly_total
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("span", {
                      className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-total"]), " ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-total-monthly"]), " float-right"),
                      children: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .getDealPrice */ .d$)(item)
                    })]
                  }), ((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isOnceOffOrder */ .y7)(item.order_type) || (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isMultiOrder */ .NO)(item.order_type)) && (item === null || item === void 0 ? void 0 : item.grand_total) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
                    className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-total-box"]), " mb-s d-flex ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["custom-history-price"]), " ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["custom-history-button"])),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("span", {
                      className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-total-lbl"])),
                      children: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_order_once_off_total */ .Z.lbl_order_once_off_total
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("span", {
                      className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-total"]), " ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-total-once-off"]), " float-right"),
                      children: item === null || item === void 0 ? void 0 : item.grand_total
                    })]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.CustomContainer, {
                  className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-btn-list"]), " d-flex"),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_11__["default"], {
                    variant: "outline black",
                    handleClick: function handleClick(event) {
                      return onOrderClick(event, item.increment_id);
                    },
                    className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["order-detail-btn"]), " btn-outline-dark ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["custom-history-button"])),
                    id: "".concat(_config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_view_order_details */ .Z.lbl_view_order_details, "--btn"),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("label", {
                      children: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_view_order_details */ .Z.lbl_view_order_details
                    })
                  }), displayTrackOrderBtn(item) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_11__["default"], {
                    varian: "solid grey",
                    className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["track-btn"]), " mb-xs ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["custom-history-button"])),
                    handleClick: function handleClick() {
                      return handleTrackOrder(item.increment_id, item.waybill_number);
                    },
                    id: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_track_this_order */ .Z.lbl_track_this_order,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("label", {
                      children: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_track_this_order */ .Z.lbl_track_this_order
                    })
                  }) : "", (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .orderPageButtons */ .Rx)(item.status).displayRetryOrderBtn ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.Fragment, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_11__["default"], {
                      varian: "solid grey",
                      className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["track-btn"]), " mb-xs ").concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["custom-history-button"])),
                      handleClick: function handleClick(event) {
                        return handleSubmit(event, item);
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("label", {
                        children: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_retry_payment_order */ .Z.lbl_retry_payment_order
                      })
                    }), (item === null || item === void 0 ? void 0 : item.increment_id) === selectedIncrementId && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      id: item === null || item === void 0 ? void 0 : item.increment_id,
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("form", {
                        method: "post",
                        name: "ucfCheckout",
                        id: "ucfCheckout",
                        onSubmit: function onSubmit(event) {
                          return handleSubmit(event, item);
                        },
                        action: props.paymentOptionsEnabled && paymentUrl ? paymentUrl : paymentConfig.paymentGatewayUrl,
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "PayserverUser",
                          id: "PayserverUser",
                          value: paymentConfig.payServerUser
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "transactionStatusCallbackUrl",
                          id: "transactionStatusCallbackUrl",
                          value: paymentConfig.transactionStatusCallbackUrl
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "transactionCompletedUrl",
                          id: "transactionCompletedUrl",
                          value: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isMultiOrder */ .NO)(item.order_type) ? postPaymentCallbackUrl : paymentCallbackUrl
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "redirectURL",
                          id: "redirectURL",
                          value: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isMultiOrder */ .NO)(item.order_type) ? postPaymentCallbackUrl : paymentCallbackUrl
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "failureURL",
                          id: "failureURL",
                          value: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_8__/* .isMultiOrder */ .NO)(item.order_type) ? postPaymentCallbackUrl : paymentCallbackUrl
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "TransactionStatusCallbackFormat",
                          id: "TransactionStatusCallbackFormat",
                          value: paymentConfig.transactionStatusCallbackFormat
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "TransactionStatusCallbackMethod",
                          id: "TransactionStatusCallbackMethod",
                          value: paymentConfig.transactionStatusCallbackMethod
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "MerchantReference",
                          id: "MerchantReference",
                          value: postOrderData === null || postOrderData === void 0 ? void 0 : postOrderData.productOrderId
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "Currency",
                          id: "Currency",
                          value: paymentConfig.currency
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "TransactionType",
                          id: "TransactionType",
                          value: paymentConfig.transactionType
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "MerchantIdentifier",
                          id: "MerchantIdentifier",
                          value: paymentConfig.merchantIdentifier
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "CustomerIdentifier",
                          id: "CustomerIdentifier",
                          value: props === null || props === void 0 ? void 0 : props.customerIdentifier
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "EncXML",
                          id: "EncXML",
                          value: postOrderData === null || postOrderData === void 0 ? void 0 : (_postOrderData$paymen = postOrderData.payment) === null || _postOrderData$paymen === void 0 ? void 0 : _postOrderData$paymen.encryptedPaymentDetails
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "hidden",
                          name: "EncType",
                          id: "EncType",
                          value: paymentConfig.encType
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                          type: "submit",
                          className: "".concat((_OrderHistoryList_module_scss__WEBPACK_IMPORTED_MODULE_16___default()["track-btn-hidden"])),
                          name: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_complete_this_order */ .Z.lbl_complete_this_order,
                          value: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_complete_this_order */ .Z.lbl_complete_this_order
                        })]
                      })
                    })]
                  }) : ""]
                })]
              })]
            })
          })
        }, index);
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.Container, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.Row, {
          className: (props === null || props === void 0 ? void 0 : props.isMobile) && "mx-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_orderHistoryLoadMore_OrderHistoryLoadMore__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            pageInfo: props === null || props === void 0 ? void 0 : props.pageInfo,
            pageNumber: props === null || props === void 0 ? void 0 : (_props$pageInfo3 = props.pageInfo) === null || _props$pageInfo3 === void 0 ? void 0 : _props$pageInfo3.current_page,
            totalPages: totalPages,
            onLoadMore: increasePageCount
          })
        })
      })]
    })
  });
};

var mapDispatchToProps = {
  setNormalCheckoutCurrentStep: _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_9__/* .setNormalCheckoutCurrentStep */ .Z9,
  setPostCheckoutCurrentStep: _Redux_actions_checkoutAction__WEBPACK_IMPORTED_MODULE_9__/* .setPostCheckoutCurrentStep */ .Gr
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isMiniApp: state.navDetails.isMiniApp
  };
};

/* harmony default export */ __webpack_exports__["default"] = ((0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_7__.connect)(mapStateToProps, mapDispatchToProps)(OrderHistoryList));

/***/ }),

/***/ 47091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99599);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28658);
/* harmony import */ var _atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79549);
/* harmony import */ var _OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6696);
/* harmony import */ var _OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var IconEndOfTheList = function IconEndOfTheList(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
      strokeLinecap: "round",
      strokeWidth: "2",
      stroke: "#999",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
        cy: "17.196",
        cx: "17",
        r: "15.833"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
        strokeLinejoin: "round",
        d: "M25.37 11 15.007 21.365 10.4 16.758"
      })]
    })
  }));
};

IconEndOfTheList.defaultProps = {
  width: "34",
  height: "35",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
};

var OrderHistoryLoadMore = function OrderHistoryLoadMore(_ref) {
  var totalPages = _ref.totalPages,
      pageNumber = _ref.pageNumber,
      pageInfo = _ref.pageInfo,
      onLoadMore = _ref.onLoadMore,
      buttonLabel = _ref.buttonLabel;
  var reachedEnd = totalPages === pageNumber;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_3__.CustomContainer, {
    className: (_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["order-load-more"]),
    children: !reachedEnd ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
      className: "p-4",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
        variant: "outline black",
        handleClick: function handleClick(event) {
          return onLoadMore(event, pageInfo);
        },
        className: "".concat((_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["order-load-more--btn"]), " mb-xs btn-outline-dark"),
        id: "load-more-btn",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("label", {
          children: buttonLabel || _config_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"].lbl_load_more_orders */ .Z.lbl_load_more_orders
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
        className: "pt-5",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(IconEndOfTheList, {
          className: (_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["order-load-list-end"])
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
        className: (_OrderHistoryLoadMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["order-load-more--label"]),
        children: _config_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"].lbl_end_order_list */ .Z.lbl_end_order_list
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OrderHistoryLoadMore);

/***/ }),

/***/ 27177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ orderHistoryTop_OrderHistoryTop; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/atoms/pageHeading/PageHeading.jsx
var PageHeading = __webpack_require__(19456);
// EXTERNAL MODULE: ./components/molecules/buttonGroups/ButtonGroup.js
var ButtonGroup = __webpack_require__(76035);
// EXTERNAL MODULE: ./components/molecules/filterButtons/FilterButtons.jsx
var FilterButtons = __webpack_require__(37665);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/molecules/buttonGroups/ButtonGroupStyle.js
var ButtonGroupStyle = __webpack_require__(41898);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/buttonGroups/ButtonGroupOrderHistory.js









var ButtonGroupOrderHistory = function ButtonGroupOrderHistory(props) {
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 992;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash),
    children: [isTablet && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          onClick: function onClick() {
            return props.toggleComps('years');
          },
          className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "left-btn-md p-s",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/icon-4px-calendar.svg"),
            alt: "years",
            className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "button-image"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "button-label",
            children: " Years: "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "button-text",
            children: [" ", props === null || props === void 0 ? void 0 : props.selectedYearVal, " "]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/caret-right.svg"),
            className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "right-arrow float-right"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          onClick: function onClick() {
            return props.toggleComps('sort');
          },
          className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "right-btn-md p-s",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/sort.svg"),
            alt: "sort",
            className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "button-image"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "button-label",
            children: [labels/* default.lbl_sort_by */.Z.lbl_sort_by, ": "]
          }), " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "button-text",
            children: [" ", props === null || props === void 0 ? void 0 : props.selectedSortVal, " "]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/caret-right.svg"),
            className: "jsx-".concat(ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash) + " " + "right-arrow float-right"
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: ButtonGroupStyle/* ButtonGroupStyle.__hash */.Y.__hash,
      children: ButtonGroupStyle/* ButtonGroupStyle */.Y
    })]
  });
};

/* harmony default export */ var buttonGroups_ButtonGroupOrderHistory = (ButtonGroupOrderHistory);
// EXTERNAL MODULE: ./components/molecules/filterNav/FilterNav.jsx + 1 modules
var FilterNav = __webpack_require__(71881);
// EXTERNAL MODULE: ./components/organisms/SortContainer/SortContainer.jsx
var SortContainer = __webpack_require__(54954);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./components/atoms/dropDown/DropDown.jsx
var DropDown = __webpack_require__(85092);
// EXTERNAL MODULE: ./components/molecules/viewOrderHistory/orderHistoryTop/OrderHistoryTop.module.scss
var OrderHistoryTop_module = __webpack_require__(51493);
var OrderHistoryTop_module_default = /*#__PURE__*/__webpack_require__.n(OrderHistoryTop_module);
;// CONCATENATED MODULE: ./components/molecules/viewOrderHistory/orderHistoryTop/OrderHistoryTop.jsx


















var OrderHistoryTop = function OrderHistoryTop(props) {
  var hideFilterOnMobile = true;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= constants/* TABLET_WIDE_WIDTH */.PH;

  var _useState = (0,react.useState)(""),
      sortProductsBy = _useState[0],
      setSortProductsBy = _useState[1];

  var _useState2 = (0,react.useState)(""),
      sortByYear = _useState2[0],
      setSortByYear = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      featureSelected = _useState3[0],
      setFeatureSelected = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showModal = _useState4[0],
      SetShowModal = _useState4[1];

  var FilterText = (0,helperServices/* getDisplayedRange */.x7)(props === null || props === void 0 ? void 0 : props.itemsLoaded, props === null || props === void 0 ? void 0 : props.totalItemsCount, labels/* default.lbl_past_orders_found */.Z.lbl_past_orders_found);

  var toggleHandler = function toggleHandler(btnClicked) {
    setFeatureSelected(btnClicked);
    btnClicked == 'sort' || btnClicked === "years" ? SetShowModal(true) : SetShowModal(false);
  };

  (0,react.useEffect)(function () {
    if (props !== null && props !== void 0 && props.resetFilter) {
      setSortByYear("");
      setSortProductsBy("");
    }
  }, [props === null || props === void 0 ? void 0 : props.resetFilter]);

  var handleResetInMobile = function handleResetInMobile(typeOfFilter) {
    if (typeOfFilter === "sort") {
      setSortProductsBy("");
      props === null || props === void 0 ? void 0 : props.sortBy("");
    }

    if (typeOfFilter === "years") {
      setSortByYear("");
      props === null || props === void 0 ? void 0 : props.sortByYear("");
    }
  };

  var handleSelectedMobile = function handleSelectedMobile(flag) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var typeOfFilter = arguments.length > 2 ? arguments[2] : undefined;

    if (flag) {
      if (typeOfFilter === "sort") {
        setSortProductsBy(value);
        props === null || props === void 0 ? void 0 : props.sortBy(value);
      }

      if (typeOfFilter === "years") {
        setSortByYear(value);
        props === null || props === void 0 ? void 0 : props.sortByYear(value);
      }
    } else {
      handleResetInMobile(typeOfFilter);
    }
  };

  var handleSelected = function handleSelected(value) {
    setSortProductsBy(value);
    props === null || props === void 0 ? void 0 : props.sortBy(value);
  };

  var handleSelectedYear = function handleSelectedYear(value) {
    setSortByYear(value);
    props === null || props === void 0 ? void 0 : props.sortByYear(value);
  };

  var checkSortModal = function checkSortModal() {
    SetShowModal(false);
    setFeatureSelected("");
  };

  var values = [{
    label: labels/* default.sortKeys.lbl_new_to_old */.Z.sortKeys.lbl_new_to_old
  }, {
    label: labels/* default.sortKeys.lbl_old_to_new */.Z.sortKeys.lbl_old_to_new
  }];

  var getYearsList = function getYearsList() {
    var currentYear = new Date().getFullYear();
    var referenceYear = labels/* default.lbl_reference_year */.Z.lbl_reference_year;
    var years = [{
      label: labels/* default.lbl_all_years */.Z.lbl_all_years
    }];

    for (var i = currentYear; i >= referenceYear; i--) {
      years.push({
        label: i
      });
    }

    return years;
  };

  var handleSearch = function handleSearch(event) {
    if (event.key === "Enter") {
      var _event$target;

      props === null || props === void 0 ? void 0 : props.handleSearchByOrderId(event.target.value);
      event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.blur();
    }
  };

  var emptyOrderList = function emptyOrderList() {
    if ((props === null || props === void 0 ? void 0 : props.totalItemsCount) > 0) {
      return "show";
    } else {
      return "hide";
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
    className: "".concat((OrderHistoryTop_module_default())["order-history-top"]),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
      className: "mx-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        className: "".concat((OrderHistoryTop_module_default())["left-col"], " pl-0 pr-0"),
        lg: 6,
        md: 12,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
          text: labels/* default.lbl_order_history_header */.Z.lbl_order_history_header,
          level: 1,
          variant: "orderHistoryMainHeader",
          className: (OrderHistoryTop_module_default()).orderHistoryMainHeader
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((OrderHistoryTop_module_default())["history-desc"], " ").concat((OrderHistoryTop_module_default())[emptyOrderList()]),
          children: labels/* default.lbl_order_history_info */.Z.lbl_order_history_info
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
        className: "".concat((OrderHistoryTop_module_default())["right-col"], " ").concat((OrderHistoryTop_module_default())[emptyOrderList()], " pl-0 pr-0"),
        lg: 6,
        md: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((OrderHistoryTop_module_default()).search, " ").concat((OrderHistoryTop_module_default())[props === null || props === void 0 ? void 0 : props.customTabletSearchClass]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "text",
            placeholder: "Search using an order number",
            className: "".concat((OrderHistoryTop_module_default())["coverage-search"]),
            onKeyPress: function onKeyPress(event) {
              return handleSearch(event);
            },
            onChange: props === null || props === void 0 ? void 0 : props.handleChange,
            value: props === null || props === void 0 ? void 0 : props.searchOrderId
          }), props !== null && props !== void 0 && props.noSearchFound ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "".concat((OrderHistoryTop_module_default()).noSearchFound, " mt-xs mb-0"),
            children: labels/* default.lbl_no_results_found */.Z.lbl_no_results_found
          }) : ""]
        })
      })]
    }), !isTablet ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
      className: "mb-3 pt-3 ".concat((OrderHistoryTop_module_default())[emptyOrderList()]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: "".concat((OrderHistoryTop_module_default())["page-info"], " ").concat((OrderHistoryTop_module_default())["page-info-text"]),
        children: FilterText
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: "".concat((OrderHistoryTop_module_default())["price-switch"], " ").concat(!isTablet ? "product-list-container" : ""),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
            className: "".concat((OrderHistoryTop_module_default())["page-info-text"], " ").concat((OrderHistoryTop_module_default())["sort-by"], " d-inline-flex align-items-center"),
            children: [labels/* default.lbl_years */.Z.lbl_years, ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            data: getYearsList(),
            handleSelect: handleSelectedYear,
            selectedValue: sortByYear === "" ? labels/* default.lbl_all_years */.Z.lbl_all_years : sortByYear,
            customClass: (OrderHistoryTop_module_default())["dropdown-item"],
            menuClassName: "sort-menu"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
            className: "".concat((OrderHistoryTop_module_default())["page-info-text"], " ").concat((OrderHistoryTop_module_default())["sort-by"], " d-inline-flex align-items-center"),
            children: [labels/* default.lbl_sort_by */.Z.lbl_sort_by, ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            data: values,
            handleSelect: handleSelected,
            selectedValue: sortProductsBy === "" ? labels/* default.sortKeys.lbl_new_to_old */.Z.sortKeys.lbl_new_to_old : sortProductsBy,
            customClass: (OrderHistoryTop_module_default())["dropdown-item"],
            menuClassName: "sort-menu"
          })]
        })]
      })]
    }) : !hideFilterOnMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((OrderHistoryTop_module_default())["filter-btn"], " ").concat((OrderHistoryTop_module_default())["custom-tablet-button"], " ").concat(emptyOrderList(), " filter-btn-group"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(buttonGroups_ButtonGroupOrderHistory, {
        toggleComps: function toggleComps(val) {
          toggleHandler(val);
        },
        selectedYearVal: sortByYear !== "" ? sortByYear : labels/* default.lbl_all_years */.Z.lbl_all_years,
        selectedSortVal: sortProductsBy != "" ? sortProductsBy : labels/* default.sortKeys.lbl_new_to_old */.Z.sortKeys.lbl_new_to_old
      })
    }), featureSelected === "sort" ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal, {
      show: showModal,
      dialogClassName: "select-modal",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderHistoryTop_module_default())["sort-gutter"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
          headingName: labels/* default.lbl_sort_by */.Z.lbl_sort_by,
          backbtn: checkSortModal,
          resetClickHandler: function resetClickHandler() {
            return handleResetInMobile('sort');
          }
        }), values.map(function (sortLabel, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SortContainer/* default */.Z, {
            close: checkSortModal,
            boxHeading: sortLabel.label,
            selected: isTablet && sortProductsBy !== "" ? sortProductsBy === sortLabel.label : false,
            selectHandler: function selectHandler(flag) {
              return handleSelectedMobile(flag, sortLabel.label, 'sort');
            }
          }, index);
        })]
      })
    }) : featureSelected === "years" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal, {
      show: showModal,
      dialogClassName: "select-modal",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderHistoryTop_module_default())["sort-gutter"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterNav/* default */.Z, {
          headingName: "Years",
          backbtn: checkSortModal,
          resetClickHandler: function resetClickHandler() {
            return handleResetInMobile('years');
          }
        }), getYearsList().map(function (year, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SortContainer/* default */.Z, {
            close: checkSortModal,
            boxHeading: year.label,
            selected: isTablet && sortByYear !== "" ? sortByYear === year.label : false,
            selectHandler: function selectHandler(flag) {
              return handleSelectedMobile(flag, year.label, 'years');
            }
          }, index);
        })]
      })
    })]
  });
};

/* harmony default export */ var orderHistoryTop_OrderHistoryTop = (OrderHistoryTop);

/***/ }),

/***/ 54954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96383);
/* harmony import */ var _SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var SortContainer = function SortContainer(_ref) {
  var boxHeading = _ref.boxHeading,
      selectHandler = _ref.selectHandler,
      selected = _ref.selected,
      close = _ref.close;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(selected),
      bgColor = _useState[0],
      setBgColor = _useState[1];

  var changeColor = function changeColor() {
    setBgColor(selected = !selected);
    selectHandler(selected);
    close();
  };

  var env = (_config_index__WEBPACK_IMPORTED_MODULE_1___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_1___default().envConfigs)[env].imagePrefix;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: (_SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boxContainer),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: bgColor && selected ? (_SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["box-clicked"]) : (_SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().box),
      onClick: changeColor,
      id: "".concat(boxHeading, "-sortby"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
        className: "".concat(bgColor && selected ? (_SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["heading-clicked"]) : (_SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().heading), " ").concat((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .toDesignation */ .ke)(boxHeading)),
        id: "".concat(boxHeading, "-sortby-after-unclicked"),
        children: boxHeading
      }), bgColor && selected && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
        src: "".concat(imagePrefix, "/assets/images/icon-green-tick.svg"),
        alt: "selected",
        className: (_SortContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["check-mark"]),
        id: "".concat(boxHeading, "-sortby-clicked")
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SortContainer);

/***/ }),

/***/ 72210:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var errorMessages = {
  compare_count_desktop_err: "You can compare up to 3 products. Try removing one to add another.",
  compare_count_mobile_err: "You can compare up to 2 products. Try removing one to add another.",
  compare_category_err: "You can compare only products within same category.",
  not_allow_place_order: "Checkout is currently unavailable. Our team is aware of this issue and are working on it. Please try again later.",
  out_of_stock: {
    collect_info: "This order can be collected from a Vodacom Shop\nYou can choose between delivery or collection options during checkout",
    multicart_standalone_out_of_stock: "One or more of the products in your cart is currently out of stock. Please remove it in order to start checkout.",
    any_out_of_stock: "One or more of the products in your cart is currently out of stock. Please remove it in order to start checkout.",
    long_delivery: "One of the items in your cart is currently not available. Delivery of your whole order will take longer than usual since we’ll need to wait for this item to become available for dispatch."
  },
  checkout: {
    errors: {
      addressForm: {
        delivery: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions"
        },
        billing: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions"
        },
        companyInformation: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions",
          companyVatName: "Please enter your company name",
          companyVatNumber: "Please enter your company VAT number"
        },
        details: {
          firstName: "Please enter your first name",
          surName: "Please enter your surname",
          cellNumber: "Please enter your cellphone number",
          email: "Please enter your email address"
        },
        contactDetails: {
          firstName: "Please enter your first name",
          surName: "Please enter your surname",
          cellNumber: "Please enter a cellphone number"
        },
        instructions: {
          instructions: "Please enter special instructions"
        }
      }
    },
    delivery: {
      unitNo: {
        onlyNumber: "Unit no. should be a number"
      },
      floorNo: {
        onlyNumber: "Unit / Floor no. should be a number"
      },
      streetNo: {
        onlyValid: "Please enter a valid street number"
      },
      streetName: {
        onlyValid: "This field cannot contain special characters"
      },
      postalCode: {
        onlyNumber: "Postal code should be a number",
        onlyValid: "Please enter valid postal code"
      }
    },
    billing: {
      unitNo: {
        onlyNumber: "Unit no. should be a number"
      },
      floorNo: {
        onlyNumber: "Unit / Floor no. should be a number"
      },
      streetNo: {
        onlyValid: "Please enter a valid street number"
      },
      streetName: {
        onlyValid: "This field cannot contain special characters"
      },
      postalCode: {
        onlyNumber: "Postal code should be a number",
        onlyValid: "Please enter valid postal code"
      }
    },
    details: {
      firstName: {
        minCharacters: "Must be longer than 2 characters"
      },
      surName: {
        minCharacters: "Must be longer than 2 characters"
      },
      email: {
        onlyValid: "Invalid email address"
      },
      cellNumber: {
        onlyNumber: "This field should only contain numbers",
        startWith: "Cellphone number must start with 0 or 27"
      }
    },
    contactDetails: {
      firstName: {
        minCharacters: "Must be longer than 2 characters"
      },
      surName: {
        minCharacters: "Must be longer than 2 characters"
      },
      cellNumber: {
        onlyNumber: "This field should only contain numbers",
        startWith: "Cellphone number must start with 0 or 27"
      }
    }
  },
  staticFormfieldErrorsMessage: {
    upgradeNumber: {
      cellNumber: "Please enter your cellphone number"
    },
    specialNeeds: {
      name: "Please enter your first name",
      surName: "Please enter your surname",
      cellNumber: "Please enter your cellphone number",
      email: "Please enter your email address",
      confirmEmail: "Please enter your email address",
      contact: "Please select your contact",
      document: "Please upload your document"
    },
    nextLevel: {
      name: "Please enter your first name",
      surName: "Please enter your surname",
      cellNumber: "Please enter your cellphone number",
      email: "Please enter your email address",
      confirmEmail: "Please enter your email address",
      saId: "Please enter your Id number"
    },
    ecommerce: {
      name: "Please enter your first name",
      surName: "Please enter your surname",
      cellNumber: "Please enter your cellphone number",
      email: "Please enter your email address",
      confirmEmail: "Please enter your email address"
    }
  },
  checkoutAuthentication: {
    errors: {
      auth: {
        idType: "Please select your ID type",
        idNumber: "Please enter your ID number",
        cellNumber: "Please enter your cellphone number",
        passportNumber: "Please enter your passport number",
        passportExpiry: "Please enter your passport expiry date",
        countryOrigin: "Please select a country of origin"
      }
    },
    idNumber: {
      onlyNumber: "This field should only contain numbers",
      minCharacters: "Please enter at least 13 characters"
    },
    cellNumber: {
      onlyNumber: "This field should only contain numbers",
      startWith: "Cellphone number must start with 0 or 27"
    },
    passportNumber: {
      onlyValid: "Please enter a valid passport number"
    },
    passportExpiry: {
      onlyValid: "Please enter a valid passport expiry date",
      sixMonthsExpiry: "Passport expiry date shouldn't be less than 6 months"
    }
  },
  creditCheckout: {
    errors: {
      personal: {
        personalDetails: {
          title: "Please select your title",
          initials: "Please enter your initials",
          firstName: "Please enter your first name",
          surName: "Please enter your last name",
          gender: "Please enter your gender",
          dob: "Please enter your date of birth",
          maritalStatus: "Please select your marital status"
        }
      },
      contact: {
        contactDetails: {
          cellNumber: "Please enter your cellphone number",
          emailAddress: "Please enter your email address"
        }
      },
      employment: {
        employmentDetails: {
          employerName: "Please enter your employer's name",
          employerNumber: "Please enter your employer's number",
          employmentType: "Please select your employment type",
          employmentCategory: "Please select your employment category",
          occupation: "Please select your occupation",
          salaryDate: "Please select your salary date",
          grossMonthlySalary: "Please enter your monthly salary before tax"
        }
      },
      home: {
        homeDetails: {
          unitNo: "Please enter a unit no.",
          complexName: "Please enter your complex name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter your suburb",
          postalCode: "Please enter your postal code",
          province: "Please select your province",
          residence: "Please select do you own or rent this property",
          town: "Please enter your town/city name",
          currentAddressPeriod: "Please enter a valid number of years and months",
          previousAddressPeriod: "Please enter a valid number of years and months"
        }
      },
      debit: {
        debitDetails: {
          bank: "Please select your bank",
          accountType: "Please select the type of account this is",
          accountNumber: "Please enter your account number",
          initials: "Please enter valid initials",
          surname: "Please enter valid surname",
          duration: "Please enter a valid number of years and months",
          debitOrderDate: "Please select the debit order date you’d prefer",
          branchName: "Please enter branch name ",
          branchCode: "Please enter your branch code"
        }
      },
      delivery: {
        deliveryDetails: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province"
        }
      }
    },
    personalDetails: {
      initials: {
        onlyValid: "Please enter valid initials"
      },
      firstName: {
        onlyValid: "Please enter a valid name",
        minCharacters: "Your first name should contain more than 2 characters"
      },
      surName: {
        onlyValid: "Please enter a valid name",
        minCharacters: "Your last name should contain more than 2 characters"
      },
      dob: {
        onlyValid: "Please enter a valid date of birth",
        minAge: "Please note that you must be over 18 to apply for a contract"
      },
      gender: {
        matchValue: "Title does not match gender"
      }
    },
    employmentDetails: {
      grossMonthlySalary: {
        onlyValid: "Please enter a valid salary amount",
        onlyZero: "This amount must be more than R0"
      },
      employerNumber: {
        onlyNumber: "This field should only contain numbers",
        startWith: "Employer's number must start with 0 or 27"
      }
    },
    homeDetails: {
      unitNo: {
        onlyNumber: "Unit no. should be a number"
      },
      streetNo: {
        onlyValid: "Please enter a valid street number"
      },
      streetName: {
        onlyValid: "This field cannot contain special characters"
      },
      postalCode: {
        onlyNumber: "Postal code should be a number",
        onlyValid: "Please enter valid postal code"
      },
      currentAddressPeriod: {
        onlyValid: "Please enter a valid number of years and months"
      },
      previousAddressPeriod: {
        onlyValid: "Please enter a valid number of years and months"
      }
    },
    debitDetails: {
      accountNumber: {
        onlyValid: "Please enter valid account number"
      },
      duration: {
        onlyValid: "Please enter a valid number of years and months"
      },
      branchCode: {
        onlyValid: "Please enter valid branch code"
      }
    },
    deliveryDetails: {
      unitNo: {
        onlyNumber: "Unit no. should be a number"
      },
      floorNo: {
        onlyNumber: "Unit / Floor no. should be a number"
      },
      streetNo: {
        onlyValid: "Please enter a valid street number"
      },
      streetName: {
        onlyValid: "This field cannot contain special characters"
      },
      postalCode: {
        onlyNumber: "Postal code should be a number",
        onlyValid: "Please enter valid postal code"
      }
    },
    contactDetails: {
      emailAddress: {
        onlyValid: "Invalid format. Please check your email address."
      },
      cellNumber: {
        onlyNumber: "This field should only contain numbers",
        startWith: "Cellphone number must start with 0 or 27"
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (errorMessages);

/***/ }),

/***/ 2272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ view_order_history; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./services/breadcrumbService.js
var breadcrumbService = __webpack_require__(74425);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/atoms/breadCrumb/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(55120);
// EXTERNAL MODULE: ./components/molecules/errorToolTip/ErrorTooltip.jsx
var ErrorTooltip = __webpack_require__(94029);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/molecules/ProductCards/ProductCards.jsx + 2 modules
var ProductCards = __webpack_require__(14309);
// EXTERNAL MODULE: ./components/molecules/viewOrderHistory/recentlyViewed/RecentlyViewed.module.scss
var RecentlyViewed_module = __webpack_require__(70805);
var RecentlyViewed_module_default = /*#__PURE__*/__webpack_require__.n(RecentlyViewed_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/viewOrderHistory/recentlyViewed/RecentlyViewed.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var _require = __webpack_require__(28658),
    Container = _require.Container,
    CustomContainer = _require.CustomContainer;







var RecentlyViewed = function RecentlyViewed(props) {
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 768;

  var handleBuyNow = function handleBuyNow(product) {
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS()), {}, {
      link_type: "o",
      link_name: "checkout: order history: buy now",
      link_url: "/product-details/".concat(product.sku)
    }));
  };

  var renderRecentlyViewed = function renderRecentlyViewed() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: props.recentViewed && props.recentViewed.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(CustomContainer, {
        className: "d-flex mb-5 pl-md-0 ".concat((RecentlyViewed_module_default()).cards),
        children: props.recentViewed.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CustomContainer, {
            className: "d-flex mr-s  ".concat((RecentlyViewed_module_default()).card),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCards["default"], {
              buttonStyleRequired: true,
              priceRequired: true,
              maximumPrice: item.price_range.maximum_price.regular_price.value,
              minimumPrice: (0,helperServices/* getAmountOffValue */.Dd)(item) === "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) !== "0" ? (0,helperServices/* getFinalPrice */.eZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item) : (0,helperServices/* getRegularPrice */.xZ)(item),
              promotionLabel: (item === null || item === void 0 ? void 0 : item.badges) != null && item !== null && item !== void 0 && item.badges_label ? item === null || item === void 0 ? void 0 : item.badges_label : "",
              promotionVariant: item.badges_label ? (0,helperServices/* getBadgeName */.n_)(item.badges_label) : "",
              promotionLabelColor: item !== null && item !== void 0 && item.badges_swatch ? item.badges_swatch : null,
              itemName: item.name,
              itemImage: item.image.url,
              imageLabel: item.label,
              imageUrl: item.image.url,
              buyNowReq: true,
              buttonLabelReq: labels/* default.lbl_buy_now */.Z.lbl_buy_now,
              promotionText: item.promotionText,
              labelText: item.labelText,
              cardHeight: isTablet ? "17.25rem" : "18.75rem",
              cardWidth: "12.5625rem",
              imgWidth: "5rem",
              imgHeight: "5rem",
              isLowStock: (0,helperServices/* checkIsLowStock */.yB)(item),
              isOutOfStock: (0,helperServices/* checkIsOutOfStock */.zy)(item),
              previousPriceReq: true,
              finalPriceReq: (0,helperServices/* checkIsFinalPriceReq */.z0)(item),
              finalPrice: (0,helperServices/* getFinalPrice */.eZ)(item),
              percentOff: (0,helperServices/* getPercentOffValue */.FQ)(item),
              amountOff: (0,helperServices/* getAmountOffValue */.Dd)(item),
              item: item,
              sku: item.sku,
              priceLabelClassName: (RecentlyViewed_module_default())["price-label"],
              finalPriceClassLabel: (RecentlyViewed_module_default())["final-price"],
              offerPriceClass: (RecentlyViewed_module_default())["offer-price-box"],
              spacingButtonMobileClassName: "recently-viewed-buyNow-btn",
              ctaHandler: handleBuyNow
            })
          }, item.sku);
        })
      }) : ""
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CustomContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomContainer, {
      className: (RecentlyViewed_module_default())["line-seperator"]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CustomContainer, {
      children: [props.recentViewed && props.recentViewed.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: (RecentlyViewed_module_default())["recent-heading"],
        children: "You recently viewed:"
      }), renderRecentlyViewed()]
    })]
  });
};

/* harmony default export */ var recentlyViewed_RecentlyViewed = (RecentlyViewed);
// EXTERNAL MODULE: ./components/molecules/viewOrderHistory/orderHistoryEmpty/OrderHistoryEmpty.module.scss
var OrderHistoryEmpty_module = __webpack_require__(92564);
var OrderHistoryEmpty_module_default = /*#__PURE__*/__webpack_require__.n(OrderHistoryEmpty_module);
;// CONCATENATED MODULE: ./components/molecules/viewOrderHistory/orderHistoryEmpty/OrderHistoryEmpty.jsx


function OrderHistoryEmpty_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OrderHistoryEmpty_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OrderHistoryEmpty_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OrderHistoryEmpty_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var IconBundles = function IconBundles(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", OrderHistoryEmpty_objectSpread(OrderHistoryEmpty_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "m17.666 39.626 31.328 14.807a2 2 0 0 0 1.71 0l31.272-14.808c1.525-.722 1.525-2.892 0-3.615l-31.27-14.812a2 2 0 0 0-1.712 0L17.666 36.01c-1.527.722-1.527 2.894 0 3.616Zm5.534-1.809 26.648-12.6 26.6 12.6-26.6 12.595L23.2 37.817Zm34.854 30.73a2 2 0 0 0 2.52.698l31.277-14.812a2 2 0 0 0 .808-2.918l-9.875-14.807a2 2 0 0 0-3.328 2.22l8.59 12.88L60.425 64.89l-8.912-13.374a2 2 0 0 0-3.328 0L39.268 64.89 11.6 51.807l8.585-12.88a2 2 0 0 0-3.328-2.219l-9.87 14.808a2 2 0 0 0 .809 2.917l31.323 14.813a2 2 0 0 0 2.52-.7l8.21-12.315 8.205 12.315ZM39.052 15.421l9.413 9.027a2 2 0 1 0 2.768-2.887l-10.406-9.98a2 2 0 0 0-2.238-.365L8.33 25.493a2 2 0 0 0-.642 3.137l9.338 10.516a2 2 0 1 0 2.991-2.656l-7.565-8.519 26.6-12.549Zm21.391 0 26.6 12.549-7.57 8.518a2 2 0 1 0 2.99 2.657l9.345-10.515a2 2 0 0 0-.642-3.138l-30.26-14.276a2 2 0 0 0-2.238.366l-10.406 9.979a2 2 0 0 0 2.768 2.887l9.413-9.027ZM49.85 83.372 20.792 69.515V57.563a2 2 0 1 0-4 0v13.213a2 2 0 0 0 1.139 1.805l31.057 14.813a2 2 0 0 0 1.722 0l31.386-14.98a2 2 0 0 0 1.138-1.805V57.396a2 2 0 1 0-4 0v11.952L49.85 83.373Zm-2-30.747v32.12a2 2 0 1 0 4 0v-32.12a2 2 0 1 0-4 0Z",
        id: "a"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h100v100H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M0 0h100v100H0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
        id: "b",
        fill: "#fff",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
          xlinkHref: "#a"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
        fill: "#333",
        fillRule: "nonzero",
        xlinkHref: "#a"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        mask: "url(#b)",
        fill: "#282828",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M0 0h100v100H0z"
        })
      })]
    })]
  }));
};

IconBundles.defaultProps = {
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};





var OrderHistoryEmpty = function OrderHistoryEmpty(_ref) {
  var _jsx2;

  var goToProducts = _ref.goToProducts,
      productItems = _ref.productItems;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
    className: "mainContainer text-center mt-m ".concat((OrderHistoryEmpty_module_default())["order-history-empty"], " ").concat(!productItems ? "mb-7" : ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((OrderHistoryEmpty_module_default())["order-history-empty--image-container"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconBundles, (_jsx2 = {
        width: "5rem"
      }, (0,defineProperty/* default */.Z)(_jsx2, "width", "5rem"), (0,defineProperty/* default */.Z)(_jsx2, "className", "d-block mx-auto ".concat((OrderHistoryEmpty_module_default())["bundles-image"])), _jsx2))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
      className: "content mt-s d-block ".concat((OrderHistoryEmpty_module_default())["order-history-empty--message"]),
      children: "You haven\u2019t made any online purchases yet"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (OrderHistoryEmpty_module_default())["button-container"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
        className: "".concat((OrderHistoryEmpty_module_default())["round-btn"], " mt-l"),
        variant: "outline black",
        handleClick: goToProducts,
        id: "start-shopping",
        children: "Start shopping"
      })
    }), productItems && /*#__PURE__*/(0,jsx_runtime.jsx)(recentlyViewed_RecentlyViewed, {
      recentViewed: productItems
    })]
  });
};

/* harmony default export */ var orderHistoryEmpty_OrderHistoryEmpty = (OrderHistoryEmpty);
// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__(21534);
;// CONCATENATED MODULE: ./pages/shopping/view-order-history.js





function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function view_order_history_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function view_order_history_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? view_order_history_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : view_order_history_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var view_order_history_require = __webpack_require__(27177),
    OrderHistoryTop = view_order_history_require["default"];

var _require2 = __webpack_require__(46325),
    OrderHistoryList = _require2["default"];

var ViewOrderHistory = function ViewOrderHistory(_ref) {
  var userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      profileLoading = _ref.profileLoading,
      paymentConfiguration = _ref.paymentConfiguration,
      trackOrderEnabled = _ref.trackOrderEnabled,
      paymentOptionsEnabled = _ref.paymentOptionsEnabled,
      isMiniApp = _ref.isMiniApp;
  var env = (config_default()).env;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var loginUrl = (config_default()).envConfigs[env].DIDLoginUrl;
  var dynamicRoute = (0,helperServices/* dynamicBreadCrumb */.sz)();
  var isMobile = (0,helperServices/* componentResize */.Y4)();

  var _useState = (0,react.useState)(false),
      viewExecuted = _useState[0],
      setViewExecuted = _useState[1];

  var _useState2 = (0,react.useState)(false),
      analytics = _useState2[0],
      setAnalytics = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      sortProductsBy = _useState3[0],
      setSortProductsBy = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      sortByYears = _useState4[0],
      setSortByYears = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      orderHistoryItems = _useState5[0],
      setOrderHistoryItems = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      orderHistoryResponse = _useState6[0],
      setOrderHistoryResponse = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      noSearchFound = _useState7[0],
      setNoSearchFound = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      updatedCookieProduct = _useState8[0],
      setUpdatedCookieProduct = _useState8[1];

  var _useState9 = (0,react.useState)({}),
      viewData = _useState9[0],
      setViewData = _useState9[1];

  var customerIdentifier = userLoggedIn && profileData !== null && profileData !== void 0 && profileData.profileID ? profileData === null || profileData === void 0 ? void 0 : profileData.profileID : "";

  var _useState10 = (0,react.useState)(),
      userMetaData = _useState10[0],
      setUserMetaData = _useState10[1];

  var _useState11 = (0,react.useState)(""),
      searchOrderId = _useState11[0],
      setSearchOrderId = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      resetFilter = _useState12[0],
      setResetFilter = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      serviceDown = _useState13[0],
      setServiceDown = _useState13[1];

  var section_lvls = {};

  var getSortQuery = function getSortQuery(sortBy) {
    switch (sortBy) {
      case labels/* default.sortKeys.lbl_old_to_new */.Z.sortKeys.lbl_old_to_new:
        return "ASC";

      case labels/* default.sortKeys.lbl_new_to_old */.Z.sortKeys.lbl_new_to_old:
      default:
        return "DESC";
    }
  };

  var parsedSku, skuArr;
  var productCookie = (0,helperServices/* getCookieValue */.Do)("products");

  if (productCookie) {
    parsedSku = JSON.parse(productCookie);
    skuArr = parsedSku.map(function (product) {
      return product.sku;
    });
  }

  (0,react.useEffect)(function () {
    if (profileLoading !== null && !profileLoading) {
      if (userLoggedIn) {
        analyticsUtag/* setAutoTagging */.fv(false);
        var tempuserMetaData = analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData);
        setUserMetaData(tempuserMetaData);
        customerPlaceOrderCall();
      } else {
        var redirectURL = loginUrl + "?redirectUrl=" + window.location.href + (isMiniApp ? "&app=true" : "");
        window.location.replace(redirectURL);
      }
    }
  }, [userLoggedIn, profileLoading]);

  var sendErrorAnalytics = function sendErrorAnalytics(error) {
    logger/* Logger.error */.Y.error(error);
    analyticsUtag/* view */.ei(view_order_history_objectSpread(view_order_history_objectSpread({
      page_event: "view",
      page_channel: "shopping",
      page_name: "checkout: order history: no past orders"
    }, section_lvls), userMetaData));
    setViewData(view_order_history_objectSpread(view_order_history_objectSpread({
      page_name: "checkout: order history: no past orders"
    }, section_lvls), userMetaData));
  };

  var getOrderHistory = function getOrderHistory(params, loadMore, isSecondCall) {
    (0,helperServices/* showSpinner */.yh)();
    ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* customerPlacedOrder */.KV, params).then(function (result) {
      var _ref2 = result || {},
          customerPlacedOrder = _ref2.customerPlacedOrder;

      if (result && result.errors) {
        var _result$errors;

        analyticsUtag/* link */.p4({
          page_name: "checkout: order history",
          page_form_event: "error",
          page_error_type: "page",
          page_errors: "[".concat(result.errors[0] ? (_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors[0].message : "", "]"),
          page_errors_code: "oh-dxl-p-ohl-".concat(result === null || result === void 0 ? void 0 : result.status)
        });
        setServiceDown(true);
      }

      if (customerPlacedOrder !== null && customerPlacedOrder !== void 0 && customerPlacedOrder.allOrderRecords) {
        setOrderHistoryResponse(customerPlacedOrder);
        var isMulti = false;

        if (loadMore) {
          var oldData = (0,toConsumableArray/* default */.Z)(orderHistoryItems);

          var newData = customerPlacedOrder.allOrderRecords;
          newData.forEach(function (item) {
            oldData.push(item);
          });
          setOrderHistoryItems(oldData);
        } else {
          setOrderHistoryItems(customerPlacedOrder.allOrderRecords);
        }

        var isMultipleOrder = customerPlacedOrder.allOrderRecords.filter(function (item) {
          return (item === null || item === void 0 ? void 0 : item.order_type) > 1;
        });

        if (isMultipleOrder.length) {
          // TODO: Fix. not sure why "arr" was used.
          // eslint-disable-next-line no-undef
          isMulti = isMultipleOrder.some(function (v) {
            return v !== arr[0];
          });
        }

        if (!isSecondCall) {
          analyticsUtag/* view */.ei(view_order_history_objectSpread(view_order_history_objectSpread({
            page_event: "view",
            page_name: "checkout: order history",
            page_channel: "shopping",
            multicart_flag: "".concat(isMulti)
          }, section_lvls), userMetaData));
        }

        setViewData(view_order_history_objectSpread(view_order_history_objectSpread({
          page_name: "checkout: order history"
        }, section_lvls), userMetaData));
        setNoSearchFound(false);
      } else {
        setOrderHistoryItems(customerPlacedOrder.allOrderRecords);
        analyticsUtag/* view */.ei(view_order_history_objectSpread(view_order_history_objectSpread({
          page_event: "view",
          page_name: "checkout: order history: no past orders",
          page_channel: "shopping",
          page_site_section_lvl_1: "Order History",
          page_site_section_lvl_2: "Home"
        }, section_lvls), userMetaData));
        setViewData(view_order_history_objectSpread(view_order_history_objectSpread({
          page_name: "checkout: order history: no past orders",
          page_site_section_lvl_1: "Order History",
          page_site_section_lvl_2: "Home"
        }, section_lvls), userMetaData));

        if (searchOrderId && searchOrderId.length > 0) {
          setNoSearchFound(true);
        } else {
          setNoSearchFound(false);
        }
      }

      (0,helperServices/* hideSpinner */.v3)();
    })["catch"](function (error) {
      sendErrorAnalytics(error);
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  var getRecentProducts = function getRecentProducts() {
    ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* Products */.QI, {
      ids: skuArr
    }).then(function (product) {
      if (product && product.errors) {
        var _product$errors;

        analyticsUtag/* link */.p4({
          page_name: "checkout: order history",
          page_form_event: "error",
          page_error_type: "page",
          page_errors: "[".concat(product.errors[0] ? (_product$errors = product.errors) === null || _product$errors === void 0 ? void 0 : _product$errors[0].message : "", "]"),
          page_errors_code: "oh-dxl-p-p-".concat(product.status)
        });
      }

      var productArr;

      if (product.products && product.products.items && (0,helperServices/* isArrayNotEmpty */.wh)(product.products.items)) {
        productArr = product.products.items;
      }

      setUpdatedCookieProduct(productArr);
    })["catch"](function (err) {
      analyticsUtag/* link */.p4({
        page_name: "checkout: order history",
        page_form_event: "error",
        page_error_type: "page",
        page_errors: "[".concat(err instanceof Error ? err.message : "", "]"),
        page_errors_code: "oh-dxl-p-p-".concat(err === null || err === void 0 ? void 0 : err.status)
      });
    });
  };

  var customerPlaceOrderCall = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var sortParam, breadcrumbs, index, _iterator, _step, item;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              _context.prev = 1;
              sortParam = getSortQuery(sortProductsBy);
              getOrderHistory({
                order_id: searchOrderId,
                year: "",
                sort: sortParam,
                pageSize: labels/* default.order_history_max_items_per_page */.Z.order_history_max_items_per_page,
                currentPage: 1
              }, false, false);
              getRecentProducts();

              if (!(Object.keys(dynamicRoute).length && !viewExecuted)) {
                _context.next = 30;
                break;
              }

              if (analytics) {
                _context.next = 30;
                break;
              }

              breadcrumbs = Object.keys(dynamicRoute).reverse();
              index = 0;
              _iterator = _createForOfIteratorHelper(breadcrumbs);
              _context.prev = 10;

              _iterator.s();

            case 12:
              if ((_step = _iterator.n()).done) {
                _context.next = 20;
                break;
              }

              item = _step.value;
              index = index + 1;

              if (!(index > 4)) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("break", 20);

            case 17:
              section_lvls["page_site_section_lvl_".concat(index)] = item;

            case 18:
              _context.next = 12;
              break;

            case 20:
              _context.next = 25;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](10);

              _iterator.e(_context.t0);

            case 25:
              _context.prev = 25;

              _iterator.f();

              return _context.finish(25);

            case 28:
              setViewExecuted(true);
              setAnalytics(true);

            case 30:
              _context.next = 36;
              break;

            case 32:
              _context.prev = 32;
              _context.t1 = _context["catch"](1);
              sendErrorAnalytics(_context.t1);
              (0,helperServices/* hideSpinner */.v3)();

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 32], [10, 22, 25, 28]]);
    }));

    return function customerPlaceOrderCall() {
      return _ref3.apply(this, arguments);
    };
  }();

  var productItems = (0,helperServices/* getProductsCookie */.X$)(parsedSku, updatedCookieProduct);

  var sortBy = function sortBy(val) {
    if (noSearchFound) {
      setSearchOrderId("");
      setNoSearchFound(false);
    }

    setSortProductsBy(val);
    var sortParam = getSortQuery(val);
    getOrderHistory({
      order_id: searchOrderId,
      year: sortByYears,
      sort: sortParam,
      pageSize: labels/* default.order_history_max_items_per_page */.Z.order_history_max_items_per_page,
      currentPage: 1
    }, false, true);
    analyticsUtag/* link */.p4(view_order_history_objectSpread(view_order_history_objectSpread({}, viewData), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: order history: filter",
      filter_query: "".concat(sortByYears ? sortByYears : labels/* default.lbl_all_years */.Z.lbl_all_years, ", ").concat(val ? val : labels/* default.sortKeys.lbl_new_to_old */.Z.sortKeys.lbl_new_to_old)
    }));
  };

  var sortByYear = function sortByYear(val) {
    if (noSearchFound) {
      setSearchOrderId("");
      setNoSearchFound(false);
    }

    var sortByYearsVal = val === labels/* default.lbl_all_years */.Z.lbl_all_years ? "" : val;
    setSortByYears(sortByYearsVal);
    var sortParam = getSortQuery(sortProductsBy);
    getOrderHistory({
      order_id: searchOrderId,
      year: sortByYearsVal,
      sort: sortParam,
      pageSize: labels/* default.order_history_max_items_per_page */.Z.order_history_max_items_per_page,
      currentPage: 1
    }, false, true);
    analyticsUtag/* link */.p4(view_order_history_objectSpread(view_order_history_objectSpread({}, viewData), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: order history: filter",
      filter_query: "".concat(val ? val : labels/* default.lbl_all_years */.Z.lbl_all_years, ", ").concat(sortProductsBy ? sortProductsBy : labels/* default.sortKeys.lbl_new_to_old */.Z.sortKeys.lbl_new_to_old)
    }));
  };

  var updateCurrentPage = function updateCurrentPage(pageNumber) {
    var sortParam = getSortQuery(sortProductsBy);
    getOrderHistory({
      order_id: "",
      year: sortByYears,
      sort: sortParam,
      pageSize: labels/* default.order_history_max_items_per_page */.Z.order_history_max_items_per_page,
      currentPage: pageNumber
    }, true, true);
  };

  var handleChange = function handleChange(e) {
    setSearchOrderId(e.target.value);
  };

  var handleSearchByOrderId = function handleSearchByOrderId(filterByOrderId) {
    analyticsUtag/* link */.p4(view_order_history_objectSpread(view_order_history_objectSpread({}, viewData), {}, {
      search_event: "search",
      search_terms: "[".concat(searchOrderId, "]"),
      search_category: "order search",
      search_type: "order search",
      page_tool_event: "use",
      page_tool_name: "shopping: order history: search orders"
    }));
    setResetFilter(true);
    setNoSearchFound(false);
    var sortParam = getSortQuery(sortProductsBy);
    getOrderHistory({
      order_id: filterByOrderId,
      year: "",
      sort: sortParam,
      pageSize: labels/* default.order_history_max_items_per_page */.Z.order_history_max_items_per_page,
      currentPage: 1
    }, false, true);
  };

  var goToProducts = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              _context2.next = 3;
              return DependencyHelper.Router.push("".concat(urlPrefix, "/products"));

            case 3:
              window.scrollTo(0, 0);
              (0,helperServices/* hideSpinner */.v3)();
              analyticsUtag/* link */.p4(view_order_history_objectSpread(view_order_history_objectSpread({}, viewData), {}, {
                link_type: "o",
                link_name: "checkout: order history: start shopping",
                link_url: "/products"
              }));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function goToProducts() {
      return _ref4.apply(this, arguments);
    };
  }();

  var renderEmptyBox = function renderEmptyBox() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(orderHistoryEmpty_OrderHistoryEmpty, {
      productItems: productItems,
      goToProducts: goToProducts
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "br-left",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb["default"], {
          list: (0,helperServices/* formatBreadCrumb */.x9)((0,breadcrumbService/* breadcrumbGenerator */.G)().orderhistory)
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderHistoryTop, {
      itemsLoaded: orderHistoryItems === null || orderHistoryItems === void 0 ? void 0 : orderHistoryItems.length,
      totalItemsCount: orderHistoryResponse === null || orderHistoryResponse === void 0 ? void 0 : orderHistoryResponse.total_count,
      sortBy: sortBy,
      sortByYear: sortByYear,
      noSearchFound: noSearchFound,
      handleSearchByOrderId: handleSearchByOrderId,
      pageInfo: orderHistoryResponse === null || orderHistoryResponse === void 0 ? void 0 : orderHistoryResponse.page_info,
      customTabletSearchClass: "custom-tablet-search",
      searchOrderId: searchOrderId,
      handleChange: handleChange,
      resetFilter: resetFilter
    }), serviceDown && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTooltip/* default */.Z, {
        type: "orders_service",
        errorMsg: labels/* default.lbl_orders_service_down */.Z.lbl_orders_service_down,
        className: "mb-7",
        hideDismissButton: true
      })
    }), (orderHistoryItems === null || orderHistoryItems === void 0 ? void 0 : orderHistoryItems.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(OrderHistoryList, {
      dataList: orderHistoryItems,
      pageInfo: orderHistoryResponse === null || orderHistoryResponse === void 0 ? void 0 : orderHistoryResponse.page_info,
      totalItemsCount: orderHistoryResponse === null || orderHistoryResponse === void 0 ? void 0 : orderHistoryResponse.total_count,
      customerIdentifier: customerIdentifier,
      isMobile: isMobile,
      updateCurrentPage: updateCurrentPage,
      paymentConfiguration: paymentConfiguration,
      trackOrderEnabled: trackOrderEnabled,
      paymentOptionsEnabled: paymentOptionsEnabled
    }) : !serviceDown && renderEmptyBox()]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userLoggedIn: state.navDetails.isUserLoggedIn,
    profileData: state.navDetails.profileData,
    profileLoading: state.navDetails.isProfileLoading,
    isMiniApp: state.navDetails.isMiniApp
  };
};

var __N_SSP = true;
/* harmony default export */ var view_order_history = ((0,DependencyHelper.connect)(mapStateToProps)((0,router.withRouter)(ViewOrderHistory)));

/***/ }),

/***/ 74425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ breadcrumbGenerator; }
/* harmony export */ });
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);



var breadcrumbGenerator = function breadcrumbGenerator(customBreadcrumb) {
  var _labels$Session_Keys, _getSessionStorage$, _labels$Session_Keys2;

  var productlistfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys === void 0 ? void 0 : _labels$Session_Keys.lbl_list_page_router_with_filters) ? (_getSessionStorage$ = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys2 = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys2 === void 0 ? void 0 : _labels$Session_Keys2.lbl_list_page_router_with_filters)[0]) === null || _getSessionStorage$ === void 0 ? void 0 : _getSessionStorage$.products : "/shopping/products";
  var dealfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") ? (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") : "/shopping/deals";
  var router = (0,_components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var breadcrumbconfig = {
    productlist: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/products",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }],
    cmsPage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.link,
      label: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.label
    }],
    productdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }],
    productcompare: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-compare",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_compare_products */ .Z.BreadCrumbLabels.lbl_compare_products
    }],
    deals: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }],
    dealdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }, {
      link: "/shopping/deal-details-page/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_deal_details */ .Z.BreadCrumbLabels.lbl_deal_details
    }],
    dealselection: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/".concat(router.query.id),
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }, {
      link: "/shopping/deal-selection",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lbl_select_deal */ .Z.lbl_select_deal
    }],
    orderhistory: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }],
    orderdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/view-order-details",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_details */ .Z.BreadCrumbLabels.lbl_order_details
    }],
    trackorder: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/track-my-order",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_track_order */ .Z.BreadCrumbLabels.lbl_track_order
    }],
    upgradePage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/upgrade",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_upgrade_page */ .Z.BreadCrumbLabels.lbl_upgrade_page
    }]
  };
  return breadcrumbconfig;
};

/***/ }),

/***/ 40547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ajaxServices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18517);
/* harmony import */ var _microServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49366);



var getPaymentOptionsData = function getPaymentOptionsData() {
  return _ajaxServices__WEBPACK_IMPORTED_MODULE_0__/* ["default"].httpGet */ .Z.httpGet("drupalBaseUrl", "_format=json", "api", "paymentOptionsData");
};

var getPaymentIntent = function getPaymentIntent(orderId, redirectUrl) {
  return _microServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("api", "paymentStoredCardsData", {
    headers: {
      "x-api-channel": "ONLINE"
    }
  }, true, null, "?orderId=".concat(orderId, "&completeUrl=").concat(redirectUrl, "&failureUrl=").concat(redirectUrl));
};

var removeStoredCard = function removeStoredCard(cardToken) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "bankCard";
  return _microServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].del */ .Z.del("api", "deleteStoredCard", {
    headers: {
      "x-api-channel": "ONLINE"
    }
  }, true, [cardToken], "?type=".concat(type));
};

var getMiniAppPaymentUrl = function getMiniAppPaymentUrl(orderId, authCode) {
  return _microServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("api", "getMiniAppPaymentUrl", {
    orderId: orderId,
    authCode: authCode
  }, {
    headers: {
      "x-api-channel": "SALES_MINI_APP"
    }
  }, false);
};

/* harmony default export */ __webpack_exports__["Z"] = ({
  getPaymentOptionsData: getPaymentOptionsData,
  getPaymentIntent: getPaymentIntent,
  removeStoredCard: removeStoredCard,
  getMiniAppPaymentUrl: getMiniAppPaymentUrl
});

/***/ }),

/***/ 11951:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/view-order-history",
      function () {
        return __webpack_require__(2272);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon-arrow":"Arrow_icon-arrow__nZGbn"};

/***/ }),

/***/ 89744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"BreadCrumb_p-xxs__heuAZ","pl-xxs":"BreadCrumb_pl-xxs__Pq2yx","pr-xxs":"BreadCrumb_pr-xxs__LOdz9","pb-xxs":"BreadCrumb_pb-xxs__dYHA5","pt-xxs":"BreadCrumb_pt-xxs__I5eh2","m-xxs":"BreadCrumb_m-xxs__BV_wk","ml-xxs":"BreadCrumb_ml-xxs__AFLMm","mr-xxs":"BreadCrumb_mr-xxs__PCCSC","mb-xxs":"BreadCrumb_mb-xxs__afj_v","mt-xxs":"BreadCrumb_mt-xxs__hsFq1","px-xxs":"BreadCrumb_px-xxs__JeufQ","mx-xxs":"BreadCrumb_mx-xxs__6nDs8","my-xxs":"BreadCrumb_my-xxs__ExH3B","py-xxs":"BreadCrumb_py-xxs___yoiL","font-size-xxs":"BreadCrumb_font-size-xxs__G3b3k","p-xs":"BreadCrumb_p-xs__Ydf2v","pl-xs":"BreadCrumb_pl-xs__4KFtt","pr-xs":"BreadCrumb_pr-xs__j5LDB","pb-xs":"BreadCrumb_pb-xs__r7wlS","pt-xs":"BreadCrumb_pt-xs__lYyC_","m-xs":"BreadCrumb_m-xs__kqGup","ml-xs":"BreadCrumb_ml-xs__9fxNn","mr-xs":"BreadCrumb_mr-xs__MnHIX","mb-xs":"BreadCrumb_mb-xs__2kV_4","mt-xs":"BreadCrumb_mt-xs__TWQWC","px-xs":"BreadCrumb_px-xs__POnB8","mx-xs":"BreadCrumb_mx-xs__NWC0P","my-xs":"BreadCrumb_my-xs__Ov9pH","py-xs":"BreadCrumb_py-xs__6k99w","font-size-xs":"BreadCrumb_font-size-xs__TDTVR","p-ss":"BreadCrumb_p-ss__8nenT","pl-ss":"BreadCrumb_pl-ss__E6s6_","pr-ss":"BreadCrumb_pr-ss__bDcG5","pb-ss":"BreadCrumb_pb-ss__J6_Jj","pt-ss":"BreadCrumb_pt-ss__V9sXm","m-ss":"BreadCrumb_m-ss__MksLc","ml-ss":"BreadCrumb_ml-ss__IgrfK","mr-ss":"BreadCrumb_mr-ss__NBuN5","mb-ss":"BreadCrumb_mb-ss__eXzqE","mt-ss":"BreadCrumb_mt-ss__RtZGW","px-ss":"BreadCrumb_px-ss__iSdiI","mx-ss":"BreadCrumb_mx-ss__gmV4s","my-ss":"BreadCrumb_my-ss__vBgaK","py-ss":"BreadCrumb_py-ss__6S3aJ","font-size-ss":"BreadCrumb_font-size-ss__8a9R5","p-ms":"BreadCrumb_p-ms__ekoV9","pl-ms":"BreadCrumb_pl-ms__D7tmj","pr-ms":"BreadCrumb_pr-ms__e2sRD","pb-ms":"BreadCrumb_pb-ms__rnAj_","pt-ms":"BreadCrumb_pt-ms__ag7m4","m-ms":"BreadCrumb_m-ms__T9KF0","ml-ms":"BreadCrumb_ml-ms__5RRFE","mr-ms":"BreadCrumb_mr-ms__wfkjE","mb-ms":"BreadCrumb_mb-ms__NUSVf","mt-ms":"BreadCrumb_mt-ms__O7sWI","px-ms":"BreadCrumb_px-ms__4XByK","mx-ms":"BreadCrumb_mx-ms__Tnh9Z","my-ms":"BreadCrumb_my-ms__2jObH","py-ms":"BreadCrumb_py-ms__QLzHK","font-size-ms":"BreadCrumb_font-size-ms__Ii_oH","p-s":"BreadCrumb_p-s__Ao5TN","pl-s":"BreadCrumb_pl-s__kmzwv","pr-s":"BreadCrumb_pr-s__0GvID","pb-s":"BreadCrumb_pb-s__LMNvJ","pt-s":"BreadCrumb_pt-s__DN70M","m-s":"BreadCrumb_m-s__Gfub1","ml-s":"BreadCrumb_ml-s__T1n7a","mr-s":"BreadCrumb_mr-s__JM_qb","mb-s":"BreadCrumb_mb-s__Y9fra","mt-s":"BreadCrumb_mt-s__TgqdQ","px-s":"BreadCrumb_px-s__B4BJD","mx-s":"BreadCrumb_mx-s__ggx55","my-s":"BreadCrumb_my-s__VOnn0","py-s":"BreadCrumb_py-s__RJTVn","font-size-s":"BreadCrumb_font-size-s__OJxvW","p-m":"BreadCrumb_p-m__4jcNq","pl-m":"BreadCrumb_pl-m__qoFdT","pr-m":"BreadCrumb_pr-m__fCW0F","pb-m":"BreadCrumb_pb-m__4_21j","pt-m":"BreadCrumb_pt-m__1bU9M","m-m":"BreadCrumb_m-m__piMyJ","ml-m":"BreadCrumb_ml-m__oBCf_","mr-m":"BreadCrumb_mr-m__p9RbI","mb-m":"BreadCrumb_mb-m__W6HyL","mt-m":"BreadCrumb_mt-m__gibKu","px-m":"BreadCrumb_px-m__NFUVV","mx-m":"BreadCrumb_mx-m__ACbJ1","my-m":"BreadCrumb_my-m__IDE7l","py-m":"BreadCrumb_py-m__I1kXn","font-size-m":"BreadCrumb_font-size-m__5EbDy","p-l":"BreadCrumb_p-l___LdZT","pl-l":"BreadCrumb_pl-l__1c4Iu","pr-l":"BreadCrumb_pr-l__euf69","pb-l":"BreadCrumb_pb-l__naQqI","pt-l":"BreadCrumb_pt-l__2H63b","m-l":"BreadCrumb_m-l__LFNUk","ml-l":"BreadCrumb_ml-l__AUqRa","mr-l":"BreadCrumb_mr-l__d60lJ","mb-l":"BreadCrumb_mb-l__xoQ9d","mt-l":"BreadCrumb_mt-l__FpoKd","px-l":"BreadCrumb_px-l__R8GEA","mx-l":"BreadCrumb_mx-l__0zBpp","my-l":"BreadCrumb_my-l__tYR_K","py-l":"BreadCrumb_py-l__fWTn6","font-size-l":"BreadCrumb_font-size-l__kHO4q","p-xl":"BreadCrumb_p-xl__sVryE","pl-xl":"BreadCrumb_pl-xl__OKP64","pr-xl":"BreadCrumb_pr-xl__6IFNa","pb-xl":"BreadCrumb_pb-xl__WaJwF","pt-xl":"BreadCrumb_pt-xl__apbAF","m-xl":"BreadCrumb_m-xl__gKVFJ","ml-xl":"BreadCrumb_ml-xl__RboKO","mr-xl":"BreadCrumb_mr-xl__dpz2h","mb-xl":"BreadCrumb_mb-xl__uOh3J","mt-xl":"BreadCrumb_mt-xl__FFF7p","px-xl":"BreadCrumb_px-xl__ITzPQ","mx-xl":"BreadCrumb_mx-xl__x7GK3","my-xl":"BreadCrumb_my-xl__2QEJ2","py-xl":"BreadCrumb_py-xl__bNH7S","font-size-xl":"BreadCrumb_font-size-xl__QyImp","p-xxl":"BreadCrumb_p-xxl__5ZYd6","pl-xxl":"BreadCrumb_pl-xxl__TlpF5","pr-xxl":"BreadCrumb_pr-xxl__Jw5VV","pb-xxl":"BreadCrumb_pb-xxl__6i7kj","pt-xxl":"BreadCrumb_pt-xxl__s5KBw","m-xxl":"BreadCrumb_m-xxl__whIb2","ml-xxl":"BreadCrumb_ml-xxl__kkiO1","mr-xxl":"BreadCrumb_mr-xxl__Rqk9w","mb-xxl":"BreadCrumb_mb-xxl__UvCHx","mt-xxl":"BreadCrumb_mt-xxl__3CXiR","px-xxl":"BreadCrumb_px-xxl__t2uey","mx-xxl":"BreadCrumb_mx-xxl__72iew","my-xxl":"BreadCrumb_my-xxl__xu_qX","py-xxl":"BreadCrumb_py-xxl__KknxS","font-size-xxl":"BreadCrumb_font-size-xxl__l_W0q","overflow-hidden":"BreadCrumb_overflow-hidden__6Pek3","topMargin":"BreadCrumb_topMargin__h_vBW","breadcrumb-wrapper":"BreadCrumb_breadcrumb-wrapper__PXx8y","breadcrumb-list":"BreadCrumb_breadcrumb-list__bwQ2f","breadcrumb-item":"BreadCrumb_breadcrumb-item__8lNEe"};

/***/ }),

/***/ 2814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown-button":"DropDownStyle_dropdown-button__x0hHN","dropdown":"DropDownStyle_dropdown__L3VfC","item":"DropDownStyle_item__y08eJ","roaming-image":"DropDownStyle_roaming-image__9IeYI","sort-menu":"DropDownStyle_sort-menu__yCnB_"};

/***/ }),

/***/ 88447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label-text":"LabelText_label-text__ss__o"};

/***/ }),

/***/ 9213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-heading":"pageHeading_page-heading__uox05","page-heading--section":"pageHeading_page-heading--section__xr7ob","page-heading--head":"pageHeading_page-heading--head__XVL9B","page-heading--tabs-heading":"pageHeading_page-heading--tabs-heading__npoPE","page-heading--campaign":"pageHeading_page-heading--campaign__1oeAi","page-heading--orderHistoryMainHeader":"pageHeading_page-heading--orderHistoryMainHeader__R1j6f","page-heading--orderDetailsMainHeader":"pageHeading_page-heading--orderDetailsMainHeader__sdB2v","page-heading--orderTrackingMainHeader":"pageHeading_page-heading--orderTrackingMainHeader__4FnyW","page-heading--product-details-heading":"pageHeading_page-heading--product-details-heading__dlAcP","alignment--left":"pageHeading_alignment--left__ngPMy","alignment--right":"pageHeading_alignment--right__nXm9c","alignment--center":"pageHeading_alignment--center__DoolE","page-heading--compare-product-header-mobile":"pageHeading_page-heading--compare-product-header-mobile__wU1ZV"};

/***/ }),

/***/ 58428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__9y82S","brand-new":"tag_brand-new__f_W4F","currently-viewing":"tag_currently-viewing__fdjKe","discount":"tag_discount__NyMX6","buy-one-get-one-free":"tag_buy-one-get-one-free__z2hQ2","device-deal":"tag_device-deal__CvIF0","limited-offer":"tag_limited-offer__u9CQE","read-hot-dealz":"tag_read-hot-dealz__ITnUK","low-stock":"tag_low-stock__GjK3M","no-stock":"tag_no-stock__vzFpN","red-hot-deal":"tag_red-hot-deal___yuSu","on-backorder":"tag_on-backorder___5HF0","pre-order":"tag_pre-order__OiaYK","exclusive-to-online":"tag_exclusive-to-online__MHLGd","one-time-offer":"tag_one-time-offer__FSShN","today-only":"tag_today-only__coPUD","for-today-only":"tag_for-today-only__C4Ugl","top-pick":"tag_top-pick__xGezC","black-friday":"tag_black-friday__wPq1G","badge-style-1":"tag_badge-style-1__wvGOX","Recommended":"tag_Recommended__ci3Kx"};

/***/ }),

/***/ 12940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"filterNav_header__ZnpEv","btnReset":"filterNav_btnReset__kPK1X","hideBtnReset":"filterNav_hideBtnReset__jmB7_","heading":"filterNav_heading__CFXm1"};

/***/ }),

/***/ 92564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"order-history-empty":"OrderHistoryEmpty_order-history-empty__NHAFh","order-history-empty--message":"OrderHistoryEmpty_order-history-empty--message__EXdZ0","order-history-empty--image-container":"OrderHistoryEmpty_order-history-empty--image-container__ZFzX8","bundles-image":"OrderHistoryEmpty_bundles-image__VdXsP","button-container":"OrderHistoryEmpty_button-container__fAPRO","round-btn":"OrderHistoryEmpty_round-btn__nIhrL"};

/***/ }),

/***/ 81076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"order-list":"OrderHistoryList_order-list__SH5PK","order-list-pagination":"OrderHistoryList_order-list-pagination__3e6AG","order-card-col":"OrderHistoryList_order-card-col__sTEzd","order-number-block":"OrderHistoryList_order-number-block__6Q_wL","order-number":"OrderHistoryList_order-number__KJFT8","type-block":"OrderHistoryList_type-block__WuSRW","product-type":"OrderHistoryList_product-type__0YkYA","order-status":"OrderHistoryList_order-status__96OI1","order-status--label":"OrderHistoryList_order-status--label__ETJhT","order-status--processing":"OrderHistoryList_order-status--processing___y4id","order-status--processed":"OrderHistoryList_order-status--processed__Z7s8f","order-status--error":"OrderHistoryList_order-status--error__mlnx7","order-status--cancelled":"OrderHistoryList_order-status--cancelled__X4KWL","blurb-message":"OrderHistoryList_blurb-message__Qkiz4","delivery-message":"OrderHistoryList_delivery-message__FHOY4","notification-message":"OrderHistoryList_notification-message__RLeAV","rectangle":"OrderHistoryList_rectangle__giYAs","order-total-box":"OrderHistoryList_order-total-box__9RknI","order-total":"OrderHistoryList_order-total__u5r_G","order-total-monthly":"OrderHistoryList_order-total-monthly__zq4WO","order-total-once-off":"OrderHistoryList_order-total-once-off__HoPX6","order-detail-btn":"OrderHistoryList_order-detail-btn__cJOst","track-btn":"OrderHistoryList_track-btn__ULcxW","order-btn-list":"OrderHistoryList_order-btn-list__5gO2X","end-order-list":"OrderHistoryList_end-order-list__mSmeG","show-more-btn":"OrderHistoryList_show-more-btn__6bJtV","track-btn-hidden":"OrderHistoryList_track-btn-hidden__Hmfjt","blurb-message--inner":"OrderHistoryList_blurb-message--inner__lgMRn","empty-block":"OrderHistoryList_empty-block__l_Rr0","custom-history-view-tablet":"OrderHistoryList_custom-history-view-tablet__3uHFM","custom-history-button":"OrderHistoryList_custom-history-button__SOPdN","custom-history-price":"OrderHistoryList_custom-history-price__zSCbN"};

/***/ }),

/***/ 6696:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"order-load-more":"OrderHistoryLoadMore_order-load-more__pVWna","order-load-more--label":"OrderHistoryLoadMore_order-load-more--label__vflkV","order-load-more--btn":"OrderHistoryLoadMore_order-load-more--btn__DKjJg","order-load-list-end":"OrderHistoryLoadMore_order-load-list-end__YsFV4"};

/***/ }),

/***/ 51493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"order-history-top":"OrderHistoryTop_order-history-top__kjlyd","filter-btn":"OrderHistoryTop_filter-btn__WlTCB","hide":"OrderHistoryTop_hide__sBmK8","search":"OrderHistoryTop_search__w9Ly1","noSearchFound":"OrderHistoryTop_noSearchFound__Uh_0r","coverage-search":"OrderHistoryTop_coverage-search__HbAB4","page-info-text":"OrderHistoryTop_page-info-text__667UU","price-switch":"OrderHistoryTop_price-switch__Xb0pn","dropdown-item":"OrderHistoryTop_dropdown-item__RPqcb","sort-by":"OrderHistoryTop_sort-by__rNMNc","price-switch-text":"OrderHistoryTop_price-switch-text__SbXdF","history-desc":"OrderHistoryTop_history-desc__L1h7S","custom-tablet-button":"OrderHistoryTop_custom-tablet-button__yj0uH","custom-tablet-search":"OrderHistoryTop_custom-tablet-search__blooR"};

/***/ }),

/***/ 70805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"recent-heading":"RecentlyViewed_recent-heading__lFzI4","cards":"RecentlyViewed_cards__aOG8Y","card":"RecentlyViewed_card__YCApV","line-seperator":"RecentlyViewed_line-seperator__wzUpD"};

/***/ }),

/***/ 96383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"SortContainer_boxContainer__5ZXVz","check-mark":"SortContainer_check-mark__P7Mup","box":"SortContainer_box__kqZvM","heading":"SortContainer_heading__WtCTh","box-clicked":"SortContainer_box-clicked__Z6cWq","heading-clicked":"SortContainer_heading-clicked__BB160"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4309,9774,2888,179], function() { return __webpack_exec__(11951); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);